// import { useState, useEffect } from 'react';
// import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Tooltip } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { useAuth } from '../../../context/AuthContext';
// import DropdownProductCode from './DropdownProductCode';
// import DeleteIcon from '@mui/icons-material/Delete';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';


// const ProductDetails = ({ initialData, onNext, clientData, connectionString, mode, isOrderLocked }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const API = connectionString;
//     const companyId = selectedCompany?.CompId || null;
//     const state = clientData?.details?.['State'];
//     const compState = selectedCompany?.State;
//     console.log('initialData', initialData);
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('md'));
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const [rows, setRows] = useState([]);
//     const [nextSrNo, setNextSrNo] = useState(1);
//     const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : '', dispatchQty: '', rate: '', disc: '', tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, });
//     const [errors, setErrors] = useState({});
//     const [editIndex, setEditIndex] = useState(null);
//     const [allProducts, setAllProducts] = useState([]);
//     const [productMap, setProductMap] = useState(new Map());
//     const [unitOptions, setUnitOptions] = useState([]);
//     const [unitMap, setUnitMap] = useState(new Map());
//     const [colorMap, setColorMap] = useState({});
//     const [sizeMap, setSizeMap] = useState({});
//     const [totals, setTotals] = useState({ basic: '0.00', discount: '0.00', cgst: '0.00', sgst: '0.00', igst: '0.00', roundOff: '0.00', total: '0.00', });
//     const [originalEditQty, setOriginalEditQty] = useState(null);
//     const [isEditingMode, setIsEditingMode] = useState(false);

//     const rowIsInvoiceLocked = (row) => {
//         return mode === 'edit' && isOrderLocked && row.challanDtsID;
//     };

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const [unitsRes, cRes, sRes] = await Promise.all([
//                     axios.get(`${API}/api/unit/retrive`, { params: { companyId } }),
//                     axios.get(`${API}/api/colormaster`),
//                     axios.get(`${API}/api/sizemaster`),
//                 ]);
//                 const unitsData = unitsRes?.data || [];
//                 const units = unitsData.map(u => u.unit);
//                 const unitIdMap = new Map(unitsData.map(u => [u.unit, u.UnitId]));
//                 setUnitOptions(units);
//                 setUnitMap(unitIdMap);
//                 const cm = {}, sm = {};
//                 cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
//                 sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
//                 setColorMap(cm);
//                 setSizeMap(sm);
//             } catch (error) {
//                 console.error('Error fetching product or unit data:', error);
//             }
//         };
//         fetchData();
//         loadAllProducts();
//     }, []);

//     const loadAllProducts = async () => {
//         try {
//             const res = await axios.get(`${API}/api/productdata/retrive`, { params: { companyId } });
//             setAllProducts(res.data || []);
//             setProductMap(new Map(res.data.map(p => [p.Id, p])));
//         } catch (e) {
//             console.error('Error loading products:', e);
//         }
//     };

//     useEffect(() => {
//         if (!initialData?.tableData || !Array.isArray(initialData.tableData)) return;
//         console.log("init data:", initialData)

//         const initialRows = initialData.tableData.map((r, index) => {
//             let qty, dispatchQty;

//             if (mode === 'edit') {
//                 // For edit mode: use raw values from database directly
//                 qty = Number(r.qty) || null;
//                 dispatchQty = Number(r.dispQty) || Number(r.dispatchQty) ;
//             } else {
//                 // For ref/add mode (step navigation): use rehydration trick
//                 const alreadyDispatched = Number(r.dispatchQty) || '';
//                 const remaining = Math.max(0, Number(r.qty) - alreadyDispatched);
//                 dispatchQty = remaining || 1;
//                 qty = remaining || 1;
//             }
//             const rate = Number(r.rate) || 0;
//             const disc = Number(r.disc) || 0;
//             const amount = Number((dispatchQty * rate * (1 - disc / 100)).toFixed(2));

//             const gst = Number(r.GST) || 0;
//             const cgst = Number(r.CGST) || 0;
//             const sgst = Number(r.SGST) || 0;
//             const igst = Number(r.IGST) || 0;

//             const taxPercent = gst || (cgst + sgst) || igst || 0;

//             let unitName = '';
//             if (r.unit && r.unit.toString().trim()) {
//                 unitName = r.unit.toString().trim();
//             } else if (r.Unit && r.Unit.toString().trim()) {
//                 unitName = r.Unit.toString().trim();
//             } else if (r.UnitId) {
//                 unitName = Array.from(unitMap.entries()).find(([_, id]) => String(id) === String(r.UnitId))?.[0] || '';
//             }

//             const row = {
//                 ...r,
//                 productId: r.productId || r.Id || r.id,
//                 Id: (r.productId || r.Id || r.id)?.toString?.() || '',
//                 UnitId: r.UnitId || null,
//                 unit: unitName,
//                 qty: qty,
//                 dispatchQty: dispatchQty,
//                 rate,
//                 disc,
//                 tax: taxPercent,
//                 amount,
//                 taxAmount: Number((amount * taxPercent / 100).toFixed(2)),
//                 taxableAmount: amount,
//                 minLevel: r.minLevel === null ? null : Number(r.minLevel) || Infinity,
//                 srNo: initialData.tableData.length - index,
//                 id: initialData.tableData.length - index,
//                 GST: `${taxPercent}%`,
//                 CGST: cgst.toString(),
//                 SGST: sgst.toString(),
//                 IGST: igst.toString(),
//                 // Preserve SO reference fields for restriction check
//                 soId: r.soId || r.SOID || null,
//                 soDtsID: r.soDtsID || r.SODtsID || null,
//                 SOID: r.soId || r.SOID || null,
//                 SODtsID: r.soDtsID || r.SODtsID || null,
//                 // Preserve challan reference fields
//                 challanDtsID: r.challanDtsID || r.ChallanDtsID || null,
//                 challanID: r.challanID || r.ChallanID || null,
//                 // ✅ ADD THESE TWO LINES:
//                 originalQty: Number(r.originalQty || r.qty) || 1,
//                 challanDispatchedQty: Number(r.challanDispatchedQty || r.dispatchQty || 0),
//             };

//             console.log(`Loading row productId=${row.productId}, soId=${row.soId}, soDtsID=${row.soDtsID}`);
//             return row;
//         });

//         setRows(initialRows);
//         setNextSrNo(initialRows.length + 1);
//     }, [initialData?.tableData, unitMap]);

//     useEffect(() => {
//         setTotals(calculateTotals());
//     }, [rows, state, compState]);

//     const calcAmount = ({ dispatchQty, rate, disc }) => Number((dispatchQty * rate * (1 - disc / 100)).toFixed(2));
//     const calcTaxAmount = ({ dispatchQty, rate, disc, tax }) => Number((dispatchQty * rate * (1 - disc / 100) * (tax / 100)).toFixed(2));

//     const calculateTotals = () => {
//         const basic = rows.reduce((sum, r) => sum + calcAmount(r), 0);
//         const discount = rows.reduce((sum, r) => sum + (r.dispatchQty * r.rate * (r.disc / 100)), 0);
//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//         const cgstTotal = isSameState ? rows.reduce((sum, r) => sum + (Number(r.CGST) * calcAmount(r) / 100), 0) : 0;
//         const sgstTotal = isSameState ? rows.reduce((sum, r) => sum + (Number(r.SGST) * calcAmount(r) / 100), 0) : 0;
//         const igstTotal = isSameState ? 0 : rows.reduce((sum, r) => sum + (Number(r.IGST) * calcAmount(r) / 100), 0);
//         const taxableTotal = basic + cgstTotal + sgstTotal + igstTotal;
//         const finalAmount = taxableTotal;
//         // const roundedFinal = Math.ceil(finalAmount);
//         // const roundOff = roundedFinal - finalAmount;
//         const decimalPart = finalAmount - Math.floor(finalAmount);
//         const roundedFinal = decimalPart >= 0.5 ? Math.ceil(finalAmount) : Math.floor(finalAmount);
//         const roundOff = roundedFinal - finalAmount;
//         console.log("taxable:", taxableTotal)

//         return {
//             basic: basic.toFixed(2),
//             discount: discount.toFixed(2),
//             cgst: cgstTotal.toFixed(2),
//             sgst: sgstTotal.toFixed(2),
//             igst: igstTotal.toFixed(2),
//             roundOff: roundOff.toFixed(2),
//             total: roundedFinal.toFixed(2),
//         };
//     };

//     const colorOptions = Object.entries(colorMap).map(([id, v]) => ({ id: +id, ...v }));
//     const sizeOptions = Object.entries(sizeMap).map(([id, v]) => ({ id: +id, ...v }));

//     useEffect(() => {
//         const dispatchQty = Number(current.dispatchQty) || 0;
//         const rate = Number(current.rate) || 0;
//         const disc = Number(current.disc) || 0;
//         const amount = calcAmount({ dispatchQty, rate, disc });
//         setCurrent(prev => ({ ...prev, amount: amount.toFixed(2) }));
//     }, [current.dispatchQty, current.rate, current.disc]);

//     const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null) => {
//         const parsedDispatchQty = Number(dispatchQty) || 0;
//         const parsedQty = Number(qty) || 0;

//         let parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? Number(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? Number(productMinLevel) : Infinity;

//         const minQty = '';

//         // 🔥 CHANGE ONLY THIS PART
//         let limit;

//         if (mode === 'add') {
//             limit = parsedMinLevel;
//         }
//         else if (mode === 'edit') {
//             limit = Math.min(parsedQty, parsedMinLevel);
//         }
//         else if (mode === 'ref') {
//             // 🔥 In ref mode → Dispatch Qty cannot exceed SO Qty
//             limit = Math.min(parsedQty, parsedMinLevel);
//         }

//         const isValid =
//             Number.isFinite(parsedDispatchQty) &&
//             parsedDispatchQty >= minQty &&
//             parsedDispatchQty <= limit;

//         return {
//             isValid,
//             correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit))
//         };
//     };

//     const hasInvalidDispatchQty = () => {
//         const rowInvalid = rows.some(row => {

//             const hasSORef =
//                 mode === 'edit' &&
//                 rowHasSOReference(row);

//             // 🔥 If edit mode AND no SO reference → skip validation
//             if (mode === 'edit' && !hasSORef) {
//                 return false;
//             }

//             const product = productMap.get(row.productId);

//             const { isValid } = validateDispatchQty(
//                 row.dispatchQty,
//                 row.qty,
//                 row.minLevel,
//                 product?.minLevel
//             );

//             return !isValid;
//         });

//         const currentInvalid =
//             mode === 'edit' && !rowHasSOReference(current)
//                 ? false
//                 : current.dispatchQty &&
//                 !validateDispatchQty(
//                     current.dispatchQty,
//                     current.qty,
//                     current.minLevel,
//                     productMap.get(current.Id)?.minLevel
//                 ).isValid;

//         return rowInvalid || currentInvalid;
//     };

//     // Helper function to check if a row has SO reference
//     const rowHasSOReference = (row) => {
//         return (row.soId || row.SOID) && (row.soDtsID || row.SODtsID);
//     };

//     // Check if ANY row has SO reference (for disabling add product button)
//     const hasAnySOReference = () => {
//         return rows.some(r => rowHasSOReference(r));
//     };

//     const handleChange = field => e => {
//         let value = e.target.value;

//         if (field === 'qty') {
//             let numeric = Number(value) || 0;

//             // Only lock when editing an existing row
//             if (editIndex != null && originalEditQty != null) {
//                 // Do NOT allow increasing beyond original qty
//                 if (numeric > originalEditQty) {
//                     numeric = originalEditQty;
//                 }
//             }

//             setCurrent(prev => ({
//                 ...prev,
//                 qty: numeric,
//             }));
//             return;
//         }

//         if (field === 'dispatchQty') {

//             const product = productMap.get(current.Id);

//             const soQty = Number(current.qty) || 1;

//             const minLevel =
//                 current.minLevel === null
//                     ? (Number(product?.minLevel) || Infinity)
//                     : Number(current.minLevel) || Infinity;

//             const limit =
//                 mode === 'add'
//                     ? minLevel
//                     : Math.min(soQty, minLevel);

//             // allow empty while typing
//             if (value === "") {
//                 setCurrent(prev => ({ ...prev, dispatchQty: "" }));
//                 return;
//             }

//             const numeric = Number(value);

//             if (field === 'dispatchQty') {

//                 // allow empty while typing
//                 if (value === "") {
//                     setCurrent(prev => ({ ...prev, dispatchQty: "" }));
//                     return;
//                 }

//                 const numeric = Number(value);

//                 // Allow any positive integer while typing
//                 if (!Number.isNaN(numeric)) {
//                     setCurrent(prev => ({
//                         ...prev,
//                         dispatchQty: numeric
//                     }));
//                 }

//                 return;
//             }

//             // ✅ only valid value will be set
//             setCurrent(prev => ({
//                 ...prev,
//                 dispatchQty: numeric
//             }));

//             // keep your existing validation
//             const { isValid } = validateDispatchQty(
//                 numeric,
//                 current.qty,
//                 current.minLevel,
//                 product?.minLevel
//             );

//             setErrors(prev => ({
//                 ...prev,
//                 dispatchQty: isValid
//                     ? undefined
//                     : `Dispatch Qty must be greater than 0 and up to ${limit}`,
//             }));

//             return;
//         }
//         else if (field === 'unit') {
//             setCurrent(prev => ({ ...prev, UnitId: unitMap.get(value) || null }));
//         }

//         setCurrent(prev => ({ ...prev, [field]: value }));
//     };


//     const handleSelect = product => {
//         // In edit mode, if any row has SO reference, don't allow selecting new products
//         if (mode === 'edit' && hasAnySOReference()) {
//             setErrors({ global: 'Cannot add new products when SO reference exists in edit mode.' });
//             return;
//         }

//         const matchedUnit = unitOptions.find(opt => {
//             if (product.UnitId && String(opt.UnitId) === String(product.UnitId)) return true;
//             if (product.Unit && opt.unit?.toLowerCase() === String(product.Unit).toLowerCase()) return true;
//             if (product.unit && opt.unit?.toLowerCase() === String(product.unit).toLowerCase()) return true;
//             return false;
//         });
//         const matchedColor = colorOptions.find(opt => opt.name.toLowerCase() === (product.color || '').toLowerCase());
//         const matchedSize = sizeOptions.find(opt => opt.name.toLowerCase() === (product.size || '').toLowerCase());
//         setCurrent({
//             Id: product.Id.toString(),
//             productCode: product.itemCode,
//             description: product.description,
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product.UnitId || ''),
//             unit: matchedUnit ? matchedUnit.unit : (product.Unit || product.unit || ''),
//             qty: mode === 'add' ? '' : '',
//             dispatchQty: '',
//             rate: Number(product.saleRate) === 0 ? '' : Number(product.saleRate),
//             disc: Number(product.saleDiscount) === 0 ? '' : Number(product.saleDiscount),
//             tax: Number(product.GST) || 0,
//             size: matchedSize?.name || '',
//             color: matchedColor?.name || '',
//             batchNo: '',
//             expDate: '',
//             serialNo: '',
//             amount: '',
//             remark: '',
//             minLevel: Number(product.minLevel) || null,
//         });
//         setEditIndex(null);
//         setErrors({});
//     };

//     const addProduct = () => {

//         const hasSORef = (current.SOID || current.soId) && (current.SODtsID || current.soDtsID);

//         // In edit mode, if any row has SO reference, don't allow adding/updating products
//         if (mode === 'edit' && hasAnySOReference()) {
//             setErrors({ global: 'Cannot add/update products when SO reference exists in edit mode.' });
//             return;
//         }

//         const errs = {};
//         const messages = new Set();
//         const requiredFields = ['productCode', 'description', 'unit', 'dispatchQty', 'tax'];

//         let missingRequired = false;
//         requiredFields.forEach(field => {
//             if (!current[field] && current[field] !== 0) {
//                 errs[field] = 'Required';
//                 missingRequired = true;
//             }
//         });

//         if (missingRequired) {
//             messages.add('All fields are required.');
//         }

//         if (mode === 'edit' && hasSORef) {
//             if (!current.qty || Number(current.qty) <= 0) {
//                 errs.qty = 'Must be > 0';
//                 messages.add('Qty must be greater than 0');
//             }
//         }

//         if (!(mode === 'edit' && !hasSORef)) {
//             if (Number(current.dispatchQty) <= 0) {
//                 errs.dispatchQty = 'Must be > 0';
//                 messages.add('Dispatch Qty must be greater than 0');
//             }
//         }

//         if (current.tax < 0) {
//             errs.tax = 'Cannot be negative';
//             messages.add('Tax cannot be negative');
//         }

//         const product = productMap.get(current.Id);
//         if (!(mode === 'edit' && !hasSORef)) {
//             const { isValid } = validateDispatchQty(
//                 current.dispatchQty,
//                 current.qty,
//                 current.minLevel,
//                 product?.minLevel
//             );

//             if (!isValid) {
//                 errs.dispatchQty = `Dispatch Qty must be valid`;
//                 messages.add(errs.dispatchQty);
//             }
//         }

//         if (messages.size > 0) {
//             errs.global = Array.from(messages);
//             setErrors(errs);
//             return;
//         }

//         const safeDisc =
//             current.disc === '' || current.disc == null
//                 ? 0
//                 : Number(current.disc);

//         const safeRate =
//             current.rate === '' || current.rate == null
//                 ? 0
//                 : Number(current.rate);


//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//         const amount = calcAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc });
//         const taxAmount = calcTaxAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc, tax: current.tax });

//         const row = {
//             ...current,
//             productId: current.Id,
//             UnitId: current.UnitId,
//             qty: Number(current.qty),
//             rate: safeRate,
//             disc: safeDisc,
//             tax: Number(current.tax) || 0,
//             remark: current.remark || '',
//             GST: `${current.tax}%`,
//             CGST: isSameState ? (current.tax / 2).toString() : '0',
//             SGST: isSameState ? (current.tax / 2).toString() : '0',
//             IGST: isSameState ? '0' : current.tax.toString(),
//             UTGST: current.UTGST || '0',
//             GSTCess: current.GSTCess || '0',
//             saleRate: current.saleRate || '0',
//             saleDiscount: current.saleDiscount || '0',
//             amount,
//             taxAmount,
//             taxableAmount: amount,
//             // No SO reference for manually added products
//             soId: current.SOID || current.SOId || null,
//             soDtsID: current.soDtsID || null,
//             SOID: current.SOID || current.SOId || null,
//             SODtsID: current.soDtsID || null,
//         };

//         // Check if productCode already exists in rows
//         const existingRowIndex = rows.findIndex(r => r.productCode === current.productCode);

//         if (existingRowIndex !== -1 && editIndex == null) {
//             // Merge with existing row
//             setRows(prev => prev.map((r, i) => {
//                 if (i === existingRowIndex) {
//                     const mergedQty = Number(r.qty) + Number(current.qty);
//                     const mergedDispatchQty = Number(r.dispatchQty) + Number(current.dispatchQty);
//                     return {
//                         ...r,
//                         // Update fields from current input
//                         UnitId: current.UnitId,
//                         unit: current.unit,
//                         qty: mergedQty,
//                         dispatchQty: mergedDispatchQty,
//                         rate: safeRate,
//                         disc: Number(current.disc) || 0,
//                         tax: Number(current.tax) || 0,
//                         GST: `${current.tax}%`,
//                         CGST: isSameState ? (current.tax / 2).toString() : '0',
//                         SGST: isSameState ? (current.tax / 2).toString() : '0',
//                         IGST: isSameState ? '0' : current.tax.toString(),
//                         amount: calcAmount({
//                             dispatchQty: mergedDispatchQty,
//                             rate: safeRate,
//                             disc: Number(current.disc)
//                         }),
//                         taxAmount: calcTaxAmount({
//                             dispatchQty: mergedDispatchQty,
//                             rate: safeRate,
//                             disc: Number(current.disc),
//                             tax: Number(current.tax)
//                         }),
//                         taxableAmount: calcAmount({
//                             dispatchQty: mergedDispatchQty,
//                             rate: safeRate,
//                             disc: Number(current.disc)
//                         }),
//                         // Preserve existing fields if not provided in current
//                         size: current.size || r.size || '',
//                         color: current.color || r.color || '',
//                         batchNo: current.batchNo || r.batchNo || '',
//                         expDate: current.expDate || r.expDate || '',
//                         serialNo: current.serialNo || r.serialNo || '',
//                         remark: current.remark || r.remark || '',
//                         minLevel: current.minLevel != null ? Number(current.minLevel) : r.minLevel,
//                         SOID: r.SOID || null,
//                         SODtsID: r.SODtsID || null,
//                         srNo: r.srNo,
//                         id: r.srNo
//                     };
//                 }
//                 return r;
//             }));
//         } else {
//             // Add new row or update edited row
//             row.srNo = editIndex != null ? rows[editIndex].srNo : nextSrNo;
//             row.id = editIndex != null ? rows[editIndex].srNo : nextSrNo;
//             if (editIndex != null) {
//                 setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
//             } else {
//                 setRows((prev) => [row, ...prev]);
//                 setNextSrNo(prev => prev + 1);
//             }
//             setIsEditingMode(false);
//         }

//         setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, });
//         setErrors({});
//         setEditIndex(null);
//         setOriginalEditQty(null);
//     };

//     const editRow = idx => {
//         const row = rows[idx];

//         // In edit mode, if this row has SO reference, don't allow editing
//         if (
//             mode === 'edit' &&
//             (rowHasSOReference(row) || rowIsInvoiceLocked(row))
//         ) {
//             setErrors({ global: 'Cannot edit this product. Invoice already created.' });
//             return;
//         }

//         setCurrent({
//             ...row,
//             rate: Number(row.rate) === 0 ? '' : row.rate,
//             disc: Number(row.disc) === 0 ? '' : row.disc,
//             dispatchQty: row.dispatchQty || 1,
//             minLevel: row.minLevel,
//             UnitId: row.UnitId || null,
//         });

//         setEditIndex(idx);
//         setOriginalEditQty(Number(row.qty) || 0);

//         setIsEditingMode(true);
//     };

//     const deleteRow = idx => {
//         const row = rows[idx];

//         // In edit mode, if this row has SO reference, don't allow deleting
//         if (mode === 'edit' && rowHasSOReference(row)) {
//             setErrors({ global: 'Cannot delete products with SO reference in edit mode.' });
//             return;
//         }

//         setRows(prev => prev.filter((_, i) => i !== idx));
//         if (idx === editIndex) {
//             setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, minLevel: null, });
//             setEditIndex(null);
//             setErrors({});
//             setOriginalEditQty(null);
//         }
//     };

//     // const handleNext = () => {
//     //     if (rows.length === 0) {
//     //         setErrors({ global: 'Add at least one product' });
//     //         return;
//     //     }

//     //     if (hasInvalidDispatchQty()) {
//     //         setErrors({ global: 'Correct invalid dispatch quantities before proceeding' });
//     //         return;
//     //     }

//     //     const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//     //     const payloadRows = rows.map(r => {
//     //         const qty = Number(r.qty) || 0;
//     //         const dispatchQty = Number(r.dispatchQty) || 0;
//     //         const taxableAmount = calcAmount(r);
//     //         const taxAmount = calcTaxAmount(r);
//     //         const cgstRate = Number(r.CGST) || (isSameState ? Number(r.tax) / 2 : 0);
//     //         const sgstRate = Number(r.SGST) || (isSameState ? Number(r.tax) / 2 : 0);
//     //         const igstRate = Number(r.IGST) || (isSameState ? 0 : Number(r.tax));
//     //         const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//     //         const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//     //         const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//     //         return {
//     //             productId: r.productId,
//     //             productCode: r.productCode,
//     //             description: r.description,
//     //             UnitId: r.UnitId,
//     //             unit: r.unit,

//     //             // Keep these original values for display in review pages:
//     //             origQty: qty,
//     //             origDispatchQty: dispatchQty,

//     //             // Keep the trick qty used by your existing useEffect rehydration logic:
//     //             qty:
//     //                 mode === 'ref'
//     //                     ? (qty + dispatchQty).toString()
//     //                     : qty.toString(),
//     //             dispatchQty: dispatchQty.toString(),

//     //             rate: r.rate.toFixed(2),
//     //             disc: r.disc.toFixed(2),
//     //             CGST: cgstRate.toFixed(2),
//     //             CGSTAmt: cgstAmt,
//     //             SGST: sgstRate.toFixed(2),
//     //             SGSTAmt: sgstAmt,
//     //             IGST: igstRate.toFixed(2),
//     //             IGSTAmt: igstAmt,
//     //             TaxId: r.TaxId || 31,
//     //             tax: Number(r.tax),
//     //             remark: r.remark || '',
//     //             amount: taxableAmount.toFixed(2),
//     //             taxAmount: taxAmount.toFixed(2),
//     //             SOID: r.SOID || r.soId || null,
//     //             SODtsID: r.SODtsID || r.soDtsID || null,
//     //             // Preserve challan reference fields
//     //             challanDtsID: r.challanDtsID || null,
//     //             challanID: r.challanID || null,
//     //         };
//     //     });

//     //     const summarySection = {
//     //         totalProducts: rows.length,
//     //         totalDispatchQty: rows.reduce((sum, r) => sum + Number(r.dispatchQty), 0),
//     //         products: rows.map(r => ({
//     //             productCode: r.productCode,
//     //             description: r.description,
//     //             dispatchQty: r.dispatchQty.toString(),
//     //             amount: calcAmount(r).toFixed(2),
//     //             taxAmount: calcTaxAmount(r).toFixed(2),
//     //         })),
//     //     };

//     //     onNext({
//     //         tableData: payloadRows,
//     //         summary: totals,
//     //         summarySection,
//     //     });

//     //     console.log('Payload sent:', { tableData: payloadRows, summary: totals, summarySection });
//     // };

//     // ✅ REPLACE THE handleNext FUNCTION IN ProductDetails.jsx
//     const handleNext = () => {
//         if (rows.length === 0) {
//             setErrors({ global: 'Add at least one product' });
//             return;
//         }

//         if (hasInvalidDispatchQty()) {
//             setErrors({ global: 'Correct invalid dispatch quantities before proceeding' });
//             return;
//         }

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         const payloadRows = rows.map(r => {
//             const dispatchQty = Number(r.dispatchQty) || 0;
//             const taxableAmount = calcAmount(r);
//             const taxAmount = calcTaxAmount(r);
//             const cgstRate = Number(r.CGST) || (isSameState ? Number(r.tax) / 2 : 0);
//             const sgstRate = Number(r.SGST) || (isSameState ? Number(r.tax) / 2 : 0);
//             const igstRate = Number(r.IGST) || (isSameState ? 0 : Number(r.tax));
//             const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//             const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//             const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//             // ✅ Use the preserved original values
//             let origQty, origDispatchQty;

//             if (mode === 'ref' && r.originalQty !== undefined) {
//                 // Use the preserved original values from database
//                 origQty = String(r.originalQty);
//                 origDispatchQty = String(r.challanDispatchedQty || 0);
//             } else if (mode === 'ref') {
//                 // Fallback if not available
//                 origQty = String(Number(r.qty) - dispatchQty || 1);
//                 origDispatchQty = String(dispatchQty);
//             } else {
//                 // Add/edit mode
//                 origQty = String(Number(r.qty) || 0);
//                 origDispatchQty = '0';
//             }

//             return {
//                 productId: r.productId,
//                 productCode: r.productCode,
//                 description: r.description,
//                 UnitId: r.UnitId,
//                 unit: r.unit,

//                 // ✅ CORRECT VALUES SENT TO BACKEND
//                 origQty: origQty,
//                 origDispatchQty: origDispatchQty,

//                 qty: String(dispatchQty),
//                 dispatchQty: String(dispatchQty),

//                 rate: r.rate.toFixed(2),
//                 disc: r.disc.toFixed(2),
//                 CGST: cgstRate.toFixed(2),
//                 CGSTAmt: cgstAmt,
//                 SGST: sgstRate.toFixed(2),
//                 SGSTAmt: sgstAmt,
//                 IGST: igstRate.toFixed(2),
//                 IGSTAmt: igstAmt,
//                 TaxId: r.TaxId || 31,
//                 tax: Number(r.tax),
//                 remark: r.remark || '',
//                 amount: taxableAmount.toFixed(2),
//                 taxAmount: taxAmount.toFixed(2),
//                 SOID: r.SOID || r.soId || null,
//                 SODtsID: r.SODtsID || r.soDtsID || null,
//                 challanDtsID: r.challanDtsID || null,
//                 challanID: r.challanID || null,
//             };
//         });

//         const summarySection = {
//             totalProducts: rows.length,
//             totalDispatchQty: rows.reduce((sum, r) => sum + Number(r.dispatchQty), 0),
//             products: rows.map(r => ({
//                 productCode: r.productCode,
//                 description: r.description,
//                 dispatchQty: r.dispatchQty.toString(),
//                 amount: calcAmount(r).toFixed(2),
//                 taxAmount: calcTaxAmount(r).toFixed(2),
//             })),
//         };

//         onNext({
//             tableData: payloadRows,
//             summary: totals,
//             summarySection,
//         });

//         console.log('✅ Payload sent:', { tableData: payloadRows, summary: totals, summarySection });
//     };

//     const formatINR = val => Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     const columns = [
//         { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
//         {
//             field: 'product', headerName: 'Product', flex: 1, sortable: true, filterable: true,
//             renderCell: params => {
//                 const { productCode, description, unit, tax, CGST, SGST, IGST, size, color, batchNo, expDate, serialNo, remark, SONumber, SODate } = params.row;
//                 const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//                 const taxableAmount = calcAmount(params.row);
//                 const cgstRate = Number(CGST) || (isSameState ? Number(tax) / 2 : 0);
//                 const sgstRate = Number(SGST) || (isSameState ? Number(tax) / 2 : 0);
//                 const igstRate = Number(IGST) || (isSameState ? 0 : Number(tax));
//                 const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//                 const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//                 const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//                 // Check if this row has SO reference for styling
//                 const hasSORef = mode === 'edit' && rowHasSOReference(params.row);

//                 return (
//                     <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
//                         <Box>
//                             <Tooltip
//                                 title={
//                                     mode === 'edit' && rowHasSOReference(params.row)
//                                         ? 'This Challan is created by reference.'
//                                         : ''
//                                 }
//                                 arrow
//                                 disableHoverListener={
//                                     !(mode === 'edit' && rowHasSOReference(params.row))
//                                 }
//                             >
//                                 <span>
//                                     <Typography
//                                         variant="body2"
//                                         fontWeight="bold"
//                                         component="div"
//                                         sx={{
//                                             cursor:
//                                                 mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row))
//                                                     ? 'not-allowed'
//                                                     : 'pointer',
//                                             color:
//                                                 mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row))
//                                                     ? '#999'
//                                                     : '#1877F2',
//                                             textDecoration:
//                                                 mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row))
//                                                     ? 'none'
//                                                     : 'underline',
//                                             fontSize: '0.85rem'
//                                         }}
//                                         onClick={e => {
//                                             e.stopPropagation();
//                                             if (!(mode === 'edit' && rowHasSOReference(params.row))) {
//                                                 editRow(params.row.index);
//                                             }
//                                         }}
//                                     >
//                                         {productCode}
//                                     </Typography>
//                                 </span>
//                             </Tooltip>


//                             <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
//                                 {description}
//                             </Typography>
//                         </Box>
//                         <Typography variant="caption" display="block"> Unit: {unit} | GST: {tax}% </Typography>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                             {isSameState ? `CGST: ₹${formatINR(cgstAmt)} + SGST: ₹${formatINR(sgstAmt)}` : `IGST: ₹${formatINR(igstAmt)}`} </Typography>
//                         {(size || color) && (<Typography variant="caption" display="block"> {size && `Size: ${size}`} {color && `| Color: ${color}`} </Typography>)}
//                         {(SONumber || SODate) && (
//                             <Typography variant="caption" display="block" color='blue'>
//                                 {SONumber && `OrderNo: ${SONumber}`}
//                                 {SODate && ` | Date: ${SODate}`}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             },
//         },
//         { field: 'qty', headerName: 'SO Qty', width: 60, align: 'center', headerAlign: 'center' },
//         {
//             field: 'dispatchQty',
//             headerName: 'Dispatch Qty',
//             width: 100,
//             align: 'center',
//             headerAlign: 'center',
//             renderCell: params => {

//                 const product = productMap.get(params.row.productId);

//                 const minLevel =
//                     params.row.minLevel === null
//                         ? Infinity
//                         : Number(params.row.minLevel) || Number(product?.minLevel) || Infinity;

//                 const hasSORef =
//                     params.row.SOID || params.row.soId
//                         ? (params.row.SODtsID || params.row.soDtsID)
//                         : false;



//                 // 🔥 FINAL LOCK CONDITION
//                 const isDispatchLocked =
//                     mode === 'edit' &&
//                     (
//                         hasSORef  // If Challan exists → lock
//                     );

//                 const soQty = Number(params.row.qty) || 0;

//                 let limit;

//                 if (mode === 'add') {
//                     // In add mode → only minLevel matters
//                     limit = minLevel;
//                 }
//                 else if (mode === 'edit' && hasSORef) {
//                     // Edit mode with SO → restrict by SO qty
//                     limit = Math.min(soQty, minLevel);
//                 }
//                 else if (mode === 'ref') {
//                     limit = Math.min(soQty, minLevel);
//                 }
//                 else {
//                     limit = minLevel;
//                 }

//                 const { isValid, correctedValue } =
//                     mode === 'edit' && !hasSORef
//                         ? { isValid: true, correctedValue: params.row.dispatchQty } // skip validation
//                         : validateDispatchQty(
//                             params.row.dispatchQty,
//                             params.row.qty,
//                             minLevel
//                         );

//                 return (
//                     <TextField
//                         type="number"
//                         size="small"
//                         value={params.row.dispatchQty}
//                         inputProps={{
//                             min: 0,
//                             max: limit,
//                             step: 'any'
//                         }}
//                         disabled={isDispatchLocked}
//                         sx={{
//                             width: 80,
//                             '& .MuiOutlinedInput-root': {
//                                 height: 38,
//                                 backgroundColor: hasSORef ? '#f5f5f5' : 'inherit',
//                             },
//                             '& .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: isValid ? undefined : 'red'
//                             },
//                         }}
//                         onChange={e => {

//                             // Lock only in EDIT mode
//                             if (mode === 'edit' && hasSORef) return;

//                             const raw = e.target.value;

//                             // Allow empty while typing
//                             if (raw === "") {
//                                 setRows(prev =>
//                                     prev.map((r, i) =>
//                                         i === params.row.index
//                                             ? { ...r, dispatchQty: "" }
//                                             : r
//                                     )
//                                 );
//                                 return;
//                             }

//                             const v = Number(raw);

//                             setRows(prev =>
//                                 prev.map((r, i) =>
//                                     i === params.row.index
//                                         ? { ...r, dispatchQty: v }
//                                         : r
//                                 )
//                             );
//                         }}
//                         onBlur={() => {
//                             if (hasSORef) return;

//                             let v = Number(params.row.dispatchQty);

//                             if (!(mode === 'edit' && !hasSORef)) {
//                                 if (!Number.isFinite(v) || v <= 0 || v > limit) {
//                                     v = correctedValue;
//                                 }
//                             }

//                             const updatedAmount = calcAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc
//                             });

//                             const updatedTaxAmount = calcTaxAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc,
//                                 tax: params.row.tax
//                             });

//                             setRows(prev =>
//                                 prev.map((r, i) =>
//                                     i === params.row.index
//                                         ? {
//                                             ...r,
//                                             dispatchQty: v,
//                                             amount: updatedAmount,
//                                             taxAmount: updatedTaxAmount,
//                                             taxableAmount: updatedAmount
//                                         }
//                                         : r
//                                 )
//                             );
//                         }}
//                     />
//                 );
//             },
//         },
//         { field: 'rate', headerName: 'Rate', width: 90, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
//         {
//             field: 'disc', headerName: 'Disc', width: 50, align: 'center', headerAlign: 'center',
//             renderHeader: () => (
//                 <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
//                     <Typography variant="body2">Disc</Typography>
//                     <Typography variant="caption" color="text.secondary">(%)</Typography>
//                 </Box>
//             ),
//         },
//         { field: 'amount', headerName: 'Amount ₹', width: 90, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.amount || 0))}` },
//         {
//             width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
//             renderCell: params => {
//                 // Check if this row has SO reference - if so, disable delete in edit mode
//                 const hasSORef =
//                     mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row));

//                 return (
//                     <IconButton
//                         size="small"
//                         onClick={() => deleteRow(params.row.index)}
//                         color="error"
//                         disabled={hasSORef || rowIsInvoiceLocked(params.row)}
//                         sx={{ opacity: hasSORef ? 0.3 : 1 }}
//                     >
//                         <DeleteIcon fontSize="small" />
//                     </IconButton>
//                 );
//             },
//         },
//     ];

//     const isAddProductDisabled = () => {
//         if (hasInvalidDispatchQty()) return true;

//         // 🔥 Disable only when adding new in ref mode
//         if (mode === 'ref' && editIndex == null) return true;

//         if (isEditingMode && editIndex == null) return true;

//         if (mode === 'edit' && isOrderLocked) return true;

//         return false;
//     };
//     return (
//         <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
//                 <Box display="flex" flexDirection="column" gap={1.5} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 1, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
//                     <Box>
//                         <DropdownProductCode
//                             id="productCode"
//                             options={allProducts}
//                             value={current.productCode}
//                             onSelect={handleSelect}
//                             onNewProductAdded={loadAllProducts}
//                             connectionString={connectionString}
//                             disabled={
//                                 mode === 'ref' ||
//                                 (mode === 'edit' && hasAnySOReference())
//                             }
//                         />
//                         {!!errors.productCode && <Typography color="error" variant="caption">{errors.productCode}</Typography>}
//                     </Box>
//                     <Typography variant="caption" color="text.secondary" sx={{ mt: -1, mt: -0.9 }}>
//                         Available Dispatch Qty: {current.minLevel === null ? 'N/A' : Number(current.minLevel) || 'N/A'}
//                     </Typography>
//                     <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} disabled={mode === 'edit' && hasAnySOReference()} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} />
//                     <Box display="flex" flexDirection="row" gap={1}>
//                         <TextField label="Unit" select required fullWidth size="small" value={current.unit} onChange={handleChange('unit')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} error={!!errors.unit} helperText={errors.unit} disabled={mode === 'edit' && hasAnySOReference()}>
//                             <option value=""></option>
//                             {unitOptions.map(u => (
//                                 <option key={u} value={u}>
//                                     {u}
//                                 </option>
//                             ))}
//                         </TextField>
//                         <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="SO Qty" size='small' fullWidth type="number" inputProps={{ min: 1 }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled />
//                     </Box>


//                     <Box display="flex" flexDirection="row" gap={1.5}>

//                         <TextField label="Qty" InputLabelProps={{ sx: requiredAsteriskStyle }} required type="number" size="small" value={current.dispatchQty}
//                             inputProps={{
//                                 min: 0,
//                                 max: (() => {
//                                     const product = productMap.get(current.Id);

//                                     const minLevel =
//                                         current.minLevel === null
//                                             ? (Number(product?.minLevel) || Infinity)
//                                             : Number(current.minLevel) || Infinity;

//                                     const hasSORef =
//                                         (current.SOID || current.soId) &&
//                                         (current.SODtsID || current.soDtsID);

//                                     if (mode === 'add') {
//                                         return minLevel;
//                                     }

//                                     if (mode === 'edit' && hasSORef) {
//                                         return Math.min(Number(current.qty) || 1, minLevel);
//                                     }

//                                     if (mode === 'ref') {
//                                         return Math.min(Number(current.qty) || 1, minLevel);
//                                     }

//                                     // ✅ edit mode without SO → free till minLevel
//                                     return minLevel;
//                                 })(),
//                                 step: 'any'
//                             }}
//                             sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: errors.dispatchQty ? 'red' : undefined }, }}
//                             onChange={handleChange('dispatchQty')}
//                             onBlur={() => {
//                                 const product = productMap.get(current.Id);

//                                 const soQty = Number(current.qty) || 0;

//                                 const minLevel =
//                                     current.minLevel === null
//                                         ? (Number(product?.minLevel) || Infinity)
//                                         : Number(current.minLevel) || Infinity;

//                                 const hasSORef =
//                                     (current.SOID || current.soId) &&
//                                     (current.SODtsID || current.soDtsID);

//                                 let limit;

//                                 if (mode === 'add') {
//                                     limit = minLevel;
//                                 }
//                                 else if (mode === 'edit' && hasSORef) {
//                                     limit = Math.min(soQty, minLevel);
//                                 }
//                                 else {
//                                     limit = minLevel;
//                                 }

//                                 let value = Number(current.dispatchQty);

//                                 if (!Number.isInteger(value) || value < 1) {
//                                     value = 1;
//                                 }

//                                 if (value > limit) {
//                                     value = limit;
//                                 }

//                                 setCurrent(prev => ({
//                                     ...prev,
//                                     dispatchQty: value
//                                 }));
//                             }}
//                             error={!!errors.dispatchQty}
//                             helperText={errors.dispatchQty}
//                             disabled={mode === 'edit' && hasAnySOReference()}
//                         />

//                         <TextField label="Rate" size="small" type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} error={!!errors.rate} helperText={errors.rate} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled={mode === 'edit' && hasAnySOReference()} />

//                         <TextField label={getColLabel(COL.DISC, 'Disc%')} size="small" type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} error={!!errors.disc} helperText={errors.disc} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled={mode === 'edit' && hasAnySOReference()} />

//                     </Box>
//                     <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} disabled={mode === 'edit' && hasAnySOReference()} />
//                     <Box display="flex" justifyContent="center">
//                         <Button
//                             variant="outlined"
//                             onClick={addProduct}
//                             sx={{ minWidth: 180 }}
//                             disabled={isAddProductDisabled()}
//                         >
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button>
//                     </Box>
//                 </Box>
//                 <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
//                     {isMobile ? (
//                         <Box>
//                             {rows.map((row, i) => (
//                                 <Box
//                                     key={i}
//                                     sx={{
//                                         border: "1px solid #cbd5e1",
//                                         borderRadius: 2,
//                                         p: 1.5,
//                                         mb: 1.5,
//                                         color: (mode === 'edit' &&
//                                             (rowHasSOReference(row) || rowIsInvoiceLocked(row))) && "text.disabled",
//                                         cursor: (mode === 'edit' &&
//                                             (rowHasSOReference(row) || rowIsInvoiceLocked(row))) ? "not-allowed" : "pointer",
//                                     }}
//                                 >
//                                     <Typography sx={{ fontWeight: 600 }}>
//                                         {row.productCode} — <span style={{ fontStyle: "italic", fontWeight: "normal" }}>
//                                             {row.description}
//                                         </span>
//                                     </Typography>

//                                     {(row.SONumber || row.SODate) && (
//                                         <Typography variant="caption" display="block" color='blue'>
//                                             {row.SONumber && `OrderNo: ${row.SONumber}`}
//                                             {row.SODate && ` | Date: ${row.SODate}`}
//                                         </Typography>
//                                     )}

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Qty:</Typography>
//                                         <Typography>{row.qty}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Rate:</Typography>
//                                         <Typography>₹{row.rate}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Disc:</Typography>
//                                         <Typography>{row.disc}%</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Amount:</Typography>
//                                         <Typography>₹{row.amount}</Typography>
//                                     </Grid>

//                                     {/* DELETE / EDIT BUTTONS IF NEEDED */}
//                                     <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
//                                         <IconButton size="small" onClick={() => editRow(i)}>
//                                             <EditIcon fontSize="small" />
//                                         </IconButton>
//                                         <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={(mode === 'edit' &&
//                                             (rowHasSOReference(row) || rowIsInvoiceLocked(row)))}>
//                                             <DeleteIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Box>
//                     ) : (
//                         <DataGrid
//                             rows={rows.map((r, i) => ({ ...r, id: i + 1, index: i }))}
//                             columns={columns}
//                             getRowHeight={() => 'auto'}
//                             autoHeight
//                             disableRowSelectionOnClick
//                             hideFooter
//                             sx={{
//                                 mt: 5,
//                                 border: '1px solid #cbd5e1',
//                                 borderRadius: 1,
//                                 '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
//                                 '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface }
//                             }}
//                         />
//                     )}
//                     <Box mt={3}>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Basic Amount</Typography>
//                             <Typography>₹{formatINR(totals.basic)}</Typography>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Discounted Amount</Typography>
//                             <Typography>₹{formatINR(totals.discount)}</Typography>
//                         </Grid>
//                         {state?.toLowerCase() === compState?.toLowerCase() ? (
//                             <>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>CGST</Typography>
//                                     <Typography>₹{formatINR(totals.cgst)}</Typography>
//                                 </Grid>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>SGST</Typography>
//                                     <Typography>₹{formatINR(totals.sgst)}</Typography>
//                                 </Grid>
//                             </>
//                         ) : (
//                             <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                 <Typography>IGST</Typography>
//                                 <Typography>₹{formatINR(totals.igst)}</Typography>
//                             </Grid>
//                         )}
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
//                             <Typography>₹{formatINR(totals.roundOff)}</Typography>
//                         </Grid>
//                         <Divider sx={{ my: 1 }} />
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Typography fontWeight={600}>Total Amount</Typography>
//                             <Typography fontWeight={600}>₹{formatINR(totals.total)}</Typography>
//                         </Grid>
//                     </Box>
//                 </Box>
//             </Box>
//             {!!errors.global && <Typography color="error" sx={{ mt: 2 }}>{errors.global}</Typography>}
//             <Box mt={0.2} display="flex" justifyContent="flex-end">
//                 <Button
//                     variant="contained"
//                     onClick={handleNext}
//                     disabled={
//                         isEditingMode ||
//                         (mode === 'edit' && isOrderLocked)
//                     }
//                 >
//                     Next
//                 </Button>
//             </Box>
//         </Paper>
//     );
// };

// export default ProductDetails;

import { colors as themeColors } from '../../../utils/theme';
import { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Tooltip, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useAuth } from '../../../context/AuthContext';
import DropdownProductCode from './DropdownProductCode';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Dropdown from '../../../components/Dropdown';
import { useVisibleColumns } from '../../../hooks/useVisibleColumns';
import { useUserDefine } from '../../../context/UserDefineContext';
import { COL, DEFAULT_LABELS } from '../../../constants/columnConstants';
import { useStockValidation } from '../../../hooks/useStockValidation';
import { colors } from "../../../utils/theme";

// "Apply in Amt = Pkg*Qty*Rate?" — when this configure is enabled, a Pkg field
// containing anything that isn't a clean number (letters/special characters) must
// make the Pkg*Qty*Rate calculation come out as 0, instead of calculateAmount()'s
// own internal `Number(pkg) || 1` silently promoting invalid input back to 1.
// Blank/null/undefined Pkg is untouched — it still defaults to 1 (existing
// behavior for a fresh row before the user has typed a Pkg value).
const isGarbagePkg = (rawPkg) =>
    rawPkg !== '' && rawPkg !== null && rawPkg !== undefined && Number.isNaN(Number(rawPkg));

const getAmountCalcSafe = (qty, rate, rawPkg, disc, isApplyPkgInAmtEnabled, calculateAmount) => {
    if (isApplyPkgInAmtEnabled && isGarbagePkg(rawPkg)) {
        return { gross: 0, taxable: 0 };
    }
    return calculateAmount(qty, rate, rawPkg, disc);
};

const ProductDetails = ({ initialData, L_No, onNext, clientData, connectionString, mode, isOrderLocked, onRowsChange }) => {
    const { user, selectedCompany, loading, configureData } = useAuth();
    const { validateMinLevel, isNegativeZeroStockBlockEnabled, validateNegativeZeroStock, isShowOnlineStockEnabled, getOnlineStockDetails, isLastSaleRateEnabled, getLastSaleRate, isApplyPkgInAmtEnabled, calculateAmount, isShowItemListPartywiseInSaleEnabled, isApplyPartywisePriceListDiscInSaleEnabled, getPriceListRate, getClientDiscount, getGroupWiseDisc, getPartywiseRate, isApplyRateOnConversionEnabled, calculateConversion, isApplyMRPInSaleEnabled, calculateSaleRateFromMRP , isDiscSchemeEnabled, getClientDiscScheme } = useStockValidation(connectionString, selectedCompany?.CompId, selectedCompany?.AppRegID);
    const { isColVisible, getColLabel, getColRow } = useVisibleColumns('CHAL');
    // RupessToBeAsk=1 ("Rupees") -> only the Oth field itself is shown (as before).
    // RupessToBeAsk=0 ("Percentage") -> also show its disabled, read-only Amount field.
    const isOthRupeesMode = (colNo) => Boolean(getColRow(colNo)?.RupessToBeAsk);
    const { getSelectedCharges, getChargeItemId, userDefineData } = useUserDefine();
    // getSelectedCharges() returns a brand-new array on every call (Array.filter),
    // even when userDefineData hasn't changed — used as a useEffect dependency
    // further down, an unstable reference there re-fires those effects (and their
    // setState calls) on every render, causing an infinite render loop. Memoize
    // on userDefineData (the actual stable source data) so the array reference
    // only changes when the underlying charges data actually changes.
    const additionalCharges = useMemo(() => getSelectedCharges('CHAL'), [userDefineData]);
    const [chargesDialogOpen, setChargesDialogOpen] = useState(false);
    const [chargesCollapsibleOpen, setChargesCollapsibleOpen] = useState(true);
    const [chargeInputs, setChargeInputs] = useState({});
    // Additional Charges contribution applied to the summary panel — populated
    // only when the user clicks Save in the Charges popup (see handleSaveCharges).
    const [chargesSummary, setChargesSummary] = useState({ total: 0, cgst: 0, sgst: 0, igst: 0 });

    // Restore chargeInputs and chargesSummary from initialData if provided (when loading an existing quotation)
    useEffect(() => {
        // API chargeInputs are already keyed by TransType (200, 201, 202, 203, 204)
        // which matches charge.TransType in additionalCharges, so no mapping needed
        if (initialData?.chargeInputs && Object.keys(initialData.chargeInputs).length > 0) {
            console.log('[ChargeInputs Debug] API chargeInputs keys:', Object.keys(initialData.chargeInputs));
            if (additionalCharges && additionalCharges.length > 0) {
                console.log('[ChargeInputs Debug] additionalCharges:', additionalCharges.map(c => ({ TransType: c.TransType, SrNo: c.SrNo, name: c.ChargeName })));
            }
            setChargeInputs(initialData.chargeInputs);
        }

        // Restore chargesSummary from charge rows in tableData (has actual calculated tax amounts)
        // This is more reliable since the API calculates taxes based on actual requirements
        if (initialData?.tableData) {
            const chargesTaxData = { total: 0, cgst: 0, sgst: 0, igst: 0 };

            initialData.tableData.forEach(row => {
                const transType = row.TransType != null ? parseInt(row.TransType) : 100;
                const isCharge = transType >= 200 && transType <= 204;
                if (isCharge) {
                    // Use the amount from the charge row
                    chargesTaxData.total += Number(row.amount || 0);
                    // Add the tax amounts from the charge row (already calculated by backend)
                    chargesTaxData.cgst += Number(row.CGSTAmt || 0);
                    chargesTaxData.sgst += Number(row.SGSTAmt || 0);
                    chargesTaxData.igst += Number(row.IGSTAmt || 0);
                }
            });

            console.log('[ChargesSummary Debug] Calculated from tableData:', chargesTaxData);

            if (chargesTaxData.total > 0 || chargesTaxData.cgst > 0 || chargesTaxData.sgst > 0 || chargesTaxData.igst > 0) {
                setChargesSummary(chargesTaxData);
            }
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setChargesSummary call) on every parent re-render, not just when
        // the actual saved charge data changes.
    }, [initialData?.chargeInputs, initialData?.tableData]);

    // Populate each charge slot's editable state (Amount, and Tax when TaxEnabled)
    // fresh every time the popup opens — default Tax is whatever was saved for
    // that slot in UserDefineColumns (charge.TaxId). Preserve amount if already restored from initialData.
    useEffect(() => {
        if (!chargesDialogOpen) return;
        setChargeInputs(prev => {
            const next = { ...prev };
            additionalCharges.forEach(charge => {
                const key = charge.TransType;
                if (!next[key]) {
                    // Only set empty amount if not already populated (e.g., from initialData restore)
                    next[key] = {
                        amount: '',
                        taxId: charge.TaxId ?? null,
                    };
                } else {
                    // Preserve existing amount, but update taxId to the configured one if not already set
                    if (next[key].taxId === null && charge.TaxId !== null) {
                        next[key].taxId = charge.TaxId;
                    }
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargesDialogOpen, additionalCharges]);

    const updateChargeInput = (key, patch) => {
        setChargeInputs(prev => ({
            ...prev,
            [key]: { ...prev[key], ...patch },
        }));
    };
    const API = connectionString;
    const companyId = selectedCompany?.CompId || null;
    // console.log('companyId:', companyId);
    const state = clientData?.details?.['State'];
    const compState = selectedCompany?.State;
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const [rows, setRows] = useState([]);
    const [nextSrNo, setNextSrNo] = useState(1);
    const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : '', dispatchQty: '', rate: '', disc: '', tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, TaxId: null, TransType: 100, PONo: '', PODate: '', POQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: '', oth2: '', oth3: '', oth4: '', oth5: '', oth6: '', oth7: '', oth1Amt: '', oth2Amt: '', oth3Amt: '', oth4Amt: '', oth5Amt: '', oth6Amt: '', oth7Amt: '', Pf: '', PfAmt: '', Insu: '', InsuAmt: '', Freight: '', FreightAmt: '', DiscAmt: '', SOQty: '', UTGST: '0.00', GSTCess: '0.00', GSTCEssAmt: '0.00', GSTOth: '0.00', GSTEduCess: '0.00', GSTEducessAmt: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TCS: '0.00', TCSAmt: '0.00', TDS: '0.00', TDSAmt: '0.00', ex4: '', ex5: '', exQty6: '', serialNo: '', defaultUnitId: '', convUnitId: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null, MRP: 0 });
    const [errors, setErrors] = useState({});
    const [editIndex, setEditIndex] = useState(null);
    // "Enable Convesrion effect in Transaction?" — Conversion Qty confirmation popup state.
    const [conversionQtyDialogOpen, setConversionQtyDialogOpen] = useState(false);
    const [conversionQtyInput, setConversionQtyInput] = useState('');
    const [pendingUnitChange, setPendingUnitChange] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [productMap, setProductMap] = useState(new Map());
    const [unitOptions, setUnitOptions] = useState([]);
    const [unitMap, setUnitMap] = useState(new Map());
    const [colorMap, setColorMap] = useState({});
    const [sizeMap, setSizeMap] = useState({});
    const [totals, setTotals] = useState({ basic: '0.00', discount: '0.00', cgst: '0.00', sgst: '0.00', igst: '0.00', roundOff: '0.00', total: '0.00', grossBasic: '0.00', });
    const [originalEditQty, setOriginalEditQty] = useState(null);
    const [isEditingMode, setIsEditingMode] = useState(false);
    const [gsts, setGsts] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [stockWarningOpen, setStockWarningOpen] = useState(false);
    const [stockWarningData, setStockWarningData] = useState(null);
    const [stockConfirmResolve, setStockConfirmResolve] = useState(null);
    const [zeroStockErrorOpen, setZeroStockErrorOpen] = useState(false);
    const [zeroStockErrorData, setZeroStockErrorData] = useState(null);
    const [onlineStockDetails, setOnlineStockDetails] = useState({
        closingStock: null,
        maxLevel: null,
        minLevel: null,
    });
    const [isInitialized, setIsInitialized] = useState(false);

    const rowIsInvoiceLocked = (row) => {
        return mode === 'edit' && isOrderLocked && row.challanDtsID;
    };

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const API_BASE = `${connectionString}/api`;

    // Track if component has finished initializing
    const hasInitializedRef = useRef(false);

    // When true, the next run of the live-calculation effect is skipped —
    // set right before a row's DB values are loaded into `current` (editRow),
    // so entering edit mode doesn't immediately overwrite the stored amount.
    const skipNextCalcRef = useRef(false);

    // Ref to the Product Code field for auto-focus
    const productCodeRef = useRef(null);

    // Notify parent when rows change — but ONLY after initialization is done
    useEffect(() => {
        if (!hasInitializedRef.current) return; // Don't fire on first empty render
        if (onRowsChange) {
            onRowsChange(rows);
        }
    }, [rows]);

    // Reset isInitialized when initialData changes (e.g., navigating between modules)
    useEffect(() => {
        if (initialData?.tableData?.length) {
            setIsInitialized(false);
            hasInitializedRef.current = false;
        }
    }, [initialData?.tableData]);

    // For add mode — no initialData, so mark as initialized immediately
    useEffect(() => {
        if (!initialData?.tableData?.length) {
            hasInitializedRef.current = true;
        }
    }, []);

    // ✅ Live recalculation: Update Oth amounts when qty/rate/disc/oth fields change (add mode)
    useEffect(() => {
        const qty = Number(current.dispatchQty || current.qty) || 0;
        const rate = Number(current.rate) || 0;
        const disc = Number(current.disc) || 0;
        if (qty === 0 || rate === 0) return; // Don't calculate if base fields empty
        const baseTaxableAmt = calcAmount({ dispatchQty: qty, rate, disc, pkg: current.pkg });
        const { taxableAmt, amounts: othAmounts } = applyOthCharges(baseTaxableAmt, current);

        setCurrent(prev => ({
            ...prev,
            ...othAmounts,
            amount: taxableAmt.toFixed(2),
            TaxableAmt: taxableAmt.toFixed(2)
        }));
    }, [current.qty, current.rate, current.disc, current.pkg,
        current.oth1, current.oth1Amt, current.oth2, current.oth2Amt,
        current.oth3, current.oth3Amt, current.oth4, current.oth4Amt,
        current.oth5, current.oth5Amt, current.oth6, current.oth6Amt,
        current.oth7, current.oth7Amt]);

    // Fetch online stock details when current product changes
    useEffect(() => {
        const fetchOnlineStock = async () => {
            if (isShowOnlineStockEnabled && current.Id) {
                console.log('📊 Challan_Stepper: Fetching online stock details for product:', current.Id);
                const details = await getOnlineStockDetails(current.Id);
                console.log('📊 Challan_Stepper: Online stock details:', details);
                setOnlineStockDetails({
                    closingStock: details.closingStock,
                    maxLevel: details.maxLevel,
                    minLevel: details.minLevel,
                });
            }
        };
        fetchOnlineStock();
    }, [current.Id, isShowOnlineStockEnabled, getOnlineStockDetails]);

    const transformGSTs = data =>
        Array.isArray(data)
            ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode }))
            : [];

    const Hlp_Fn_GST = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
            console.log(data)
            setGsts(transformGSTs(data));
        } catch (e) {
            console.error('GST lookup failed', e);
            setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
            setGsts([]);
        }
    };

    useEffect(() => {
        Hlp_Fn_GST();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [unitsRes, cRes, sRes] = await Promise.all([
                    axios.get(`${API}/api/unit/retrive`, { params: { companyId } }),
                    axios.get(`${API}/api/colormaster`),
                    axios.get(`${API}/api/sizemaster`),
                ]);
                const unitsData = unitsRes?.data || [];
                // console.log('unitsData:', unitsData);
                const unitList = unitsData.map(u => ({
                    UnitId: u.UnitId,
                    unit: u.unit
                }));

                setUnitOptions(unitList);
                const cm = {}, sm = {};
                cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
                sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
                setColorMap(cm);
                setSizeMap(sm);
            } catch (error) {
                console.error('Error fetching product or unit data:', error);
            }
        };
        fetchData();
        loadAllProducts();
    }, []);

    const handleProductAdded = async () => {
        // Reload units when product is added
        try {
            const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
                params: { companyId }
            });
            setUnitOptions(unitsRes.data);

            // Also reload products
            await loadAllProducts();
        } catch (error) {
            console.error('Error refreshing data:', error);
        }
    };

    const loadAllProducts = async () => {
        try {
            // When "Show Item List Partywise in Sale?" is enabled, pass partyId so the
            // API joins with partywiserate and returns only items configured for this client.
            const params = { companyId, mode: 'SALE' };
            if (isShowItemListPartywiseInSaleEnabled && clientData?.clientId) {
                params.partyId = clientData.clientId;
                params.AppRegID = selectedCompany?.AppRegID;
            }

            const res = await axios.get(`${API}/api/productdata/retrive`, { params });
            setAllProducts(res.data || []);
            setProductMap(new Map(res.data.map(p => [p.Id, p])));
        } catch (e) {
            console.error('Error loading products:', e);
        }
    };

    const getTaxPercent = (value) => {
        if (!value) return 0;

        // remove % sign
        const cleaned = value.replace('%', '').trim();

        const parsed = parseFloat(cleaned);

        return isNaN(parsed) ? 0 : parsed;
    };

    useEffect(() => {
        if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !gsts.length || !allProducts.length) return;
        console.log("init data:", initialData)




        // The products grid (`rows`) must only ever hold normal product rows.
        // Additional Charges (TransType 200-204) and RoundOff (300) are restored
        // separately (chargeInputs / roundOff field) and re-added at submit time —
        // including them here as well would duplicate them in the outgoing payload.
        const regularRows = initialData.tableData.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);

        const initialRows = regularRows.map((r, index) => {
            const regularIndex = index;
            const srNoValue = regularRows.length - regularIndex;
            let qty, dispatchQty;

            if (mode === 'edit') {
                // For edit mode: use raw values from database directly
                qty = Number(r.qty) || null;
                dispatchQty = Number(r.dispQty) || Number(r.dispatchQty);
            } else {
                // For ref/add mode (step navigation): use rehydration trick
                // const alreadyDispatched = Number(r.dispatchQty) || '';
                // const remaining = Math.max(0, Number(r.qty) - alreadyDispatched);
                // dispatchQty = remaining || 1;
                // qty = remaining || 1;
                qty = Number(r.qty) || 0;
                dispatchQty = Number(r.dispatchQty) || Number(r.qty) || 0;

                // If qty is 0, it means fully dispatched - this shouldn't happen as backend filters it out
                // But as a safety net, set minimum to 1 only if qty > 0
                if (qty === 0) {
                    console.warn(`Product ${r.productCode} has 0 qty - should have been filtered by backend`);
                }
            }
            const rate = Number(r.rate) || 0;
            const disc = Number(r.disc) || 0;
            // Prefer the exact amount stored in the database over recomputing it —
            // recomputing here can silently diverge from what was actually saved
            // (e.g. if a Pkg-based calculation produced the stored value). Only
            // fall back to a fresh calculation when the DB has no stored amount.
            // This only applies in edit mode: in ref/add mode the order-fetch API
            // computes `amount` from the already-dispatched qty (0 for a fresh
            // order), while `dispatchQty` above is corrected to the full remaining
            // qty — so the stored amount is stale and must always be recalculated.
            const storedAmt = r.amount ?? r.TaxableAmt ?? r.taxableAmount;
            const hasStoredAmt = mode === 'edit' && storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
            // Oth1→Oth7 are re-applied on top of the freshly-calculated base whenever
            // the stored amount isn't trusted (ref/add mode), mirroring Add/Update
            // Product so a referenced row's amount is correct immediately on load.
            const freshBaseAmt = getAmountCalcSafe(dispatchQty, rate, r.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
            const amount = hasStoredAmt ? Number(storedAmt) : applyOthCharges(freshBaseAmt, r).taxableAmt;

            let taxId = r.taxId || r.TaxId || null;

            //  GST lookup
            const matchedGST = gsts.find(g => String(g.Id) === String(taxId));

            //  final %
            const taxPercent = matchedGST
                ? getTaxPercent(matchedGST.value)
                : Number(r.tax) || (Number(r.CGST) + Number(r.SGST)) || Number(r.IGST) || 0;

            // const gst = Number(r.GST) || 0;

            console.log("taxPercant", taxPercent)

            //  split taxes
            const isSameState = state?.toLowerCase() === compState?.toLowerCase();

            const cgst = isSameState ? taxPercent / 2 : 0;
            const sgst = isSameState ? taxPercent / 2 : 0;
            const igst = !isSameState ? taxPercent : 0;


            console.log(cgst, sgst, igst)


            let unitName = '';

            if (r.UnitId) {
                unitName = unitOptions.find(u => String(u.UnitId) === String(r.UnitId))?.unit || '';
            } else if (r.unit) {
                unitName = r.unit;
            }

            // "Enable Convesrion effect in Transaction?" — resolve this row's product from
            // allProducts (same as handleSelect) purely to re-derive the UI-only
            // defaultUnitId/convUnitId/productConvQty fields below; nothing else
            // in this mapping depends on it.
            const product = allProducts.find(p => p.Id === (r.productId || r.Id || r.id) || p.itemCode === r.productCode);
            const matchedUnit = r.UnitId
                ? unitOptions.find(u => String(u.UnitId) === String(r.UnitId))
                : null;

            const row = {
                ...r,
                productId: r.productId || r.Id || r.id,
                Id: (r.productId || r.Id || r.id)?.toString?.() || '',
                UnitId: r.UnitId || null,
                unit: unitName,
                qty: qty,
                dispatchQty: dispatchQty,
                rate,
                disc,
                tax: taxPercent,
                amount,
                TaxId: taxId,
                // "Enable Convesrion effect in Transaction?" — re-derive these UI-only fields from
                // the product's CURRENT registered defaults (same as handleSelect),
                // since they're never persisted and a saved row's editRow spread
                // would otherwise leave defaultUnitId unset, silently disabling the
                // Unit-change conversion prompt in edit mode. baseRate stays the
                // ORIGINAL pre-conversion rate: r.ConversionRate when a conversion
                // was active on this saved row, else the row's own rate.
                defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId ? String(product.UnitId) : ''),
                convUnitId: product?.ConvUnit ? String(product.ConvUnit) : '',
                productConvQty: Number(product?.ConvQty) || '',
                baseRate: r.ConversionRate != null ? Number(r.ConversionRate) : rate,
                taxAmount: Number((amount * taxPercent / 100).toFixed(2)),
                taxableAmount: amount,
                minLevel: r.minLevel === null ? null : Number(r.minLevel) || Infinity,
                srNo: srNoValue,
                id: srNoValue,
                GST: `${taxPercent}%`,
                CGST: cgst,
                SGST: sgst,
                IGST: igst,
                // Preserve SO reference fields for restriction check
                soId: r.soId || r.SOID || null,
                soDtsID: r.soDtsID || r.SODtsID || null,
                SOID: r.soId || r.SOID || null,
                SODtsID: r.soDtsID || r.SODtsID || null,
                // Preserve challan reference fields
                challanDtsID: r.challanDtsID || r.ChallanDtsID || null,
                challanID: r.challanID || r.ChallanID || null,
                // ✅ ADD THESE TWO LINES:
                originalQty: Number(r.originalQty || r.qty) || 1,
                challanDispatchedQty: Number(r.challanDispatchedQty || r.dispatchQty || 0),
                TransType: r.TransType || 100,
            };

            console.log(`Loading row productId=${row.productId}, soId=${row.soId}, soDtsID=${row.soDtsID}`);
            return row;
        });

        setRows(initialRows);
        setNextSrNo(initialRows.length + 1);
        setIsInitialized(true);
        hasInitializedRef.current = true; // ← for lifting rows state up
    }, [initialData?.tableData, unitMap, gsts, allProducts]);

    // Re-load products when party-wise filter config or selected client changes
    // to ensure dropdown always shows the correct filtered list based on current settings
    useEffect(() => {
        loadAllProducts();
    }, [isShowItemListPartywiseInSaleEnabled, clientData?.clientId]);

    useEffect(() => {
        setTotals(calculateTotals());
    }, [rows, state, compState, chargesSummary]);

    // Pkg is folded in only when "Apply in Amt = Pkg*Qty*Rate?" is enabled — see
    // calculateAmount in useStockValidation.js. pkg defaults to 1 when empty/0,
    // matching Invoice_Steeper's behavior.
    const calcAmount = ({ dispatchQty, rate, disc, pkg }) => getAmountCalcSafe(dispatchQty, rate, pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
    const calcTaxAmount = ({ dispatchQty, rate, disc, tax, pkg }) => Number((calcAmount({ dispatchQty, rate, disc, pkg }) * (tax / 100)).toFixed(2));

    // Prefer each row's own stored amount over recomputing it from today's live
    // Pkg-flag setting — that flag may have changed since the row was saved
    // (see calcAmount above). Only recalculate when the row truly has no
    // stored amount (e.g. a brand-new row not yet saved).
    // In ref/add mode this must always recalculate: editing Dispatch Qty in the
    // grid only updates row.dispatchQty (see the setRows calls above), it never
    // refreshes row.amount, so a stale "0.00" carried over from the order-fetch
    // API (computed off the already-dispatched qty, not the qty being dispatched
    // now) would otherwise stick in the summary even after the user changes qty.
    const effectiveRowAmount = r => {
        const storedAmt = r.amount ?? r.TaxableAmt ?? r.taxableAmount;
        const hasStoredAmt = storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
        return hasStoredAmt ? Number(storedAmt) : calcAmount(r);
    };

    const calculateTotals = () => {
        const regularRows = rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);
        const basic = regularRows.reduce((sum, r) => sum + effectiveRowAmount(r), 0);
        const pkgGrossOf = (r) => getAmountCalcSafe(r.dispatchQty, r.rate, r.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
        const discount = regularRows.reduce((sum, r) => sum + (pkgGrossOf(r) * (r.disc / 100)), 0);
        // Gross = dispatchQty*rate, BEFORE Disc%/Oth — used only for BasicAmt/BasicAmount storage.
        let grossAmountSum = 0;
        regularRows.forEach(r => {
            const gross = pkgGrossOf(r);
            grossAmountSum += gross;
        });
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        const cgstTotal = isSameState ? regularRows.reduce((sum, r) => sum + (Number(r.CGST) * effectiveRowAmount(r) / 100), 0) : 0;
        const sgstTotal = isSameState ? regularRows.reduce((sum, r) => sum + (Number(r.SGST) * effectiveRowAmount(r) / 100), 0) : 0;
        const igstTotal = isSameState ? 0 : regularRows.reduce((sum, r) => sum + (Number(r.IGST) * effectiveRowAmount(r) / 100), 0);
        const taxableTotal = basic + cgstTotal + sgstTotal + igstTotal;
        // Fold Additional Charges (amount + their own GST) into the pre-rounding
        // amount so Round Off reflects the actual payable total, not just products.
        const chargesTotal = Number(chargesSummary.total || 0)
            + Number(chargesSummary.cgst || 0)
            + Number(chargesSummary.sgst || 0)
            + Number(chargesSummary.igst || 0);
        const finalAmount = taxableTotal + chargesTotal;
        // const roundedFinal = Math.ceil(finalAmount);
        // const roundOff = roundedFinal - finalAmount;
        const decimalPart = finalAmount - Math.floor(finalAmount);
        const roundedFinal = decimalPart >= 0.5 ? Math.ceil(finalAmount) : Math.floor(finalAmount);
        const roundOff = roundedFinal - finalAmount;

        return {
            basic: basic.toFixed(2),
            discount: discount.toFixed(2),
            cgst: cgstTotal.toFixed(2),
            sgst: sgstTotal.toFixed(2),
            igst: igstTotal.toFixed(2),
            roundOff: roundOff.toFixed(2),
            total: roundedFinal.toFixed(2),
            grossBasic: grossAmountSum.toFixed(2),
        };
    };

    // Additional Charges: given a charge and its current popup input, compute
    // the charge amount, the tax on it (only when TaxEnabled), and the final
    // (tax-inclusive) amount — this is what "Final Amount" displays live.
    const getChargeFinalAmounts = (charge, input) => {
        const chargeAmount = Number(input?.amount) || 0;
        if (!charge.TaxEnabled) {
            return { chargeAmount, taxPercent: 0, taxAmount: 0, finalAmount: chargeAmount };
        }
        const selectedGST = gsts.find(g => String(g.Id) === String(input?.taxId));
        const taxPercent = parseFloat(selectedGST?.value) || 0;
        const taxAmount = chargeAmount * taxPercent / 100;
        return { chargeAmount, taxPercent, taxAmount, finalAmount: chargeAmount + taxAmount };
    };

    // Additional Charges: on Save, fold every charge's final amount into the
    // Total Amount shown in the summary, and its tax (if any) into CGST+SGST
    // (same state) or IGST (different state) — same split rule calculateTotals
    // already uses for product rows.
    const handleSaveCharges = () => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
        setChargesDialogOpen(false);
    };

    // ✅ Auto-sync chargesSummary with chargeInputs whenever charges are entered
    // This ensures charges are calculated in real-time without needing a Save button
    useEffect(() => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
    }, [chargeInputs, additionalCharges, state, compState]);

    const colorOptions = Object.entries(colorMap).map(([id, v]) => ({ id: +id, ...v }));
    const sizeOptions = Object.entries(sizeMap).map(([id, v]) => ({ id: +id, ...v }));

    useEffect(() => {
        // `current` was just loaded from a saved row (editRow) — skip this one
        // pass so the DB-stored amount isn't immediately overwritten before the
        // user has actually changed anything.
        if (skipNextCalcRef.current) {
            skipNextCalcRef.current = false;
            return;
        }

        const dispatchQty = Number(current.dispatchQty) || 0;
        const rate = Number(current.rate) || 0;
        const disc = Number(current.disc) || 0;
        const amount = calcAmount({ dispatchQty, rate, disc, pkg: current.pkg });
        setCurrent(prev => ({ ...prev, amount: amount.toFixed(2) }));
    }, [current.dispatchQty, current.rate, current.disc, current.pkg, isApplyPkgInAmtEnabled]);

    const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null) => {
        const parsedDispatchQty = Number(dispatchQty) || 0;
        const parsedQty = Number(qty) || 0;

        let parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? Number(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? Number(productMinLevel) : Infinity;

        const minQty = '';

        // 🔥 CHANGE ONLY THIS PART
        let limit;

        if (mode === 'add') {
            limit = parsedMinLevel;
        }
        else if (mode === 'edit') {
            limit = Math.min(parsedQty, parsedMinLevel);
        }
        else if (mode === 'ref') {
            // 🔥 In ref mode → Dispatch Qty cannot exceed SO Qty
            limit = Math.min(parsedQty, parsedMinLevel);
        }

        const isValid =
            Number.isFinite(parsedDispatchQty) &&
            parsedDispatchQty >= minQty &&
            parsedDispatchQty <= limit;

        return {
            isValid,
            correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit))
        };
    };

    const hasInvalidDispatchQty = () => {
        const rowInvalid = rows.some(row => {

            const hasSORef =
                mode === 'edit' &&
                rowHasSOReference(row);

            // 🔥 If edit mode AND no SO reference → skip validation
            if (mode === 'edit' && !hasSORef) {
                return false;
            }

            const product = productMap.get(row.productId);

            const { isValid } = validateDispatchQty(
                row.dispatchQty,
                row.qty,
                row.minLevel,
                product?.minLevel
            );

            return !isValid;
        });

        const currentInvalid =
            mode === 'edit' && !rowHasSOReference(current)
                ? false
                : current.dispatchQty &&
                !validateDispatchQty(
                    current.dispatchQty,
                    current.qty,
                    current.minLevel,
                    productMap.get(current.Id)?.minLevel
                ).isValid;

        return rowInvalid || currentInvalid;
    };

    // Helper function to check if a row has SO reference
    const rowHasSOReference = (row) => {
        return (row.soId || row.SOID) && (row.soDtsID || row.SODtsID);
    };

    // Check if ANY row has SO reference (for disabling add product button)
    const hasAnySOReference = () => {
        return rows.some(r => rowHasSOReference(r));
    };

    const handleChange = field => e => {
        let value = e.target.value;

        if (field === 'qty') {
            let numeric = Number(value) || 0;

            // Only lock when editing an existing row
            if (editIndex != null && originalEditQty != null) {
                // Do NOT allow increasing beyond original qty
                if (numeric > originalEditQty) {
                    numeric = originalEditQty;
                }
            }

            setCurrent(prev => {
                const updated = {
                    ...prev,
                    qty: numeric,
                };
                // Qty shifts the base amount Oth1-7 are computed from — reapply
                // them live here too, same as Disc already does via handleBaseFieldChange.
                return { ...updated, ...recomputeTaxable(updated) };
            });
            return;
        }

        if (field === 'dispatchQty') {

            const product = productMap.get(current.Id);

            const soQty = Number(current.qty) || 1;

            const minLevel =
                current.minLevel === null
                    ? (Number(product?.minLevel) || Infinity)
                    : Number(current.minLevel) || Infinity;

            const limit =
                mode === 'add'
                    ? minLevel
                    : Math.min(soQty, minLevel);

            // allow empty while typing
            if (value === "") {
                setCurrent(prev => ({ ...prev, dispatchQty: "" }));
                return;
            }

            const numeric = Number(value);

            if (field === 'dispatchQty') {

                // allow empty while typing
                if (value === "") {
                    setCurrent(prev => ({ ...prev, dispatchQty: "" }));
                    return;
                }

                const numeric = Number(value);

                // Allow any positive integer while typing
                if (!Number.isNaN(numeric)) {
                    setCurrent(prev => ({
                        ...prev,
                        dispatchQty: numeric
                    }));
                }

                return;
            }

            // ✅ only valid value will be set
            setCurrent(prev => ({
                ...prev,
                dispatchQty: numeric
            }));

            // keep your existing validation
            const { isValid } = validateDispatchQty(
                numeric,
                current.qty,
                current.minLevel,
                product?.minLevel
            );

            setErrors(prev => ({
                ...prev,
                dispatchQty: isValid
                    ? undefined
                    : `Dispatch Qty must be greater than 0 and up to ${limit}`,
            }));

            return;
        }
        if (field === 'UnitId') {
            const selected = unitOptions.find(u => String(u.UnitId) === String(e.target.value));
            const newUnitId = e.target.value;

            // "Enable Convesrion effect in Transaction?" — switching away from the product's own
            // default Unit prompts for the Conversion Qty ratio before applying it.
            if (isApplyRateOnConversionEnabled && current.defaultUnitId && String(newUnitId) !== String(current.defaultUnitId)) {
                setPendingUnitChange({
                    UnitId: newUnitId,
                    unit: selected ? selected.unit : '',
                    previousUnitId: current.UnitId,
                });
                const matchesConvUnit = current.convUnitId && String(newUnitId) === String(current.convUnitId);
                setConversionQtyInput(matchesConvUnit && current.productConvQty ? String(current.productConvQty) : '1');
                setConversionQtyDialogOpen(true);
                return;
            }

            // Reverting to the product's own default Unit (or config is off) —
            // behave exactly as before, and clear any previously-active conversion.
            setCurrent(prev => ({
                ...prev,
                UnitId: newUnitId,
                unit: selected ? selected.unit : '',
                ConversionQty: null,
                ConversionRate: null,
                rate: prev.defaultUnitId && String(newUnitId) === String(prev.defaultUnitId) ? prev.baseRate : prev.rate,
            }));
            return;
        }

        if (field === 'rate' || field === 'pkg') {
            // Rate/Pkg also shift the base amount Oth1-7 are computed from —
            // reapply them live here too, same as Disc already does via handleBaseFieldChange.
            setCurrent(prev => {
                const updated = { ...prev, [field]: value };
                return { ...updated, ...recomputeTaxable(updated) };
            });
            return;
        }

        setCurrent(prev => ({ ...prev, [field]: value }));
    };

    // Oth1→Oth7: each one's amount is applied in order on top of the running
    // TaxableAmt (qty*rate*(1-disc/100) as the starting base) — Percentage mode
    // takes its % against the running total so far (not the original base),
    // Rupees mode adds/subtracts a flat value; AddLess=1 means subtract, 0 means add.
    const OTH_FIELDS = [
        { field: 'oth1', col: COL.OTH1 },
        { field: 'oth2', col: COL.OTH2 },
        { field: 'oth3', col: COL.OTH3 },
        { field: 'oth4', col: COL.OTH4 },
        { field: 'oth5', col: COL.OTH5 },
        { field: 'oth6', col: COL.OTH6 },
        { field: 'oth7', col: COL.OTH7 },
    ];
    // Applies Oth1→Oth7 in order on top of `base`, returning both the final
    // taxable amount AND each Oth's own computed rupee contribution (so the
    // disabled "Oth N Amount" field — oth{N}Amt — has something to show in
    // Percentage mode). Used both for the live preview while editing and for
    // the actual Add/Update Product commit, so the two never disagree.
    const applyOthCharges = (base, rowState) => {
        let running = base;
        const amounts = {};
        OTH_FIELDS.forEach(({ field, col }) => {
            const amtField = `${field}Amt`;
            const row = getColRow(col);
            const isRupees = Boolean(row?.RupessToBeAsk);
            const isMinus = Boolean(row?.AddLess);
            // Rupees mode: OthN itself is left 0 in the DB (decimal(5,2), not
            // meant to hold a rupee amount) — the real typed value lives in
            // OthNAmt, so that's the source of truth to read back here too.
            const raw = isRupees ? rowState[amtField] : rowState[field];
            const val = Number(raw);
            if (!raw || Number.isNaN(val) || val === 0) {
                amounts[amtField] = 0;
                return;
            }
            const contribution = isRupees ? val : (running * val) / 100;
            // Rupees mode: amtField IS the field the user is actively typing into
            // (othDisplayField routes it there) — reformatting it with toFixed(2)
            // on every keystroke changes the string under the cursor and resets
            // cursor position to the end. Keep the raw typed text as-is; it's only
            // ever Number()'d downstream, so the unformatted string is fine.
            // Percentage mode's amtField is a separate disabled/read-only display,
            // so reformatting it is safe and keeps it looking like a computed amount.
            amounts[amtField] = isRupees ? raw : contribution.toFixed(2);
            running = isMinus ? running - contribution : running + contribution;
        });
        return { taxableAmt: running, amounts };
    };
    // Recomputes base=qty*rate*(1-disc/100) + Oth1→Oth7 from whatever's currently
    // in `updated`, returning the fields to merge back into state. Shared by both
    // the Oth field handler and the Qty/Rate/Disc handlers so TaxableAmt/amount
    // stay Oth-adjusted live, no matter which of the four fields just changed.
    const recomputeTaxable = (updated) => {
        const qty = Number(updated.qty) || 0;
        const rate = Number(updated.rate) || 0;
        const disc = Number(updated.disc) || 0;
        // Use the same Pkg-aware calc as Add Product/handleNext (getAmountCalcSafe)
        // instead of raw qty*rate*(1-disc/100) — otherwise live Oth1-7 typing
        // ignores Pkg*Qty*Rate when "Apply in Amt = Pkg*Qty*Rate?" is enabled.
        const base = getAmountCalcSafe(qty, rate, updated.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
        const { taxableAmt, amounts } = applyOthCharges(base, updated);
        return { ...amounts, TaxableAmt: taxableAmt.toFixed(2), amount: taxableAmt.toFixed(2) };
    };
    // Rupees mode: OthN itself stays 0 in the DB, so the field the user
    // actually types/sees is OthNAmt directly. Percentage mode: the user
    // types the % into OthN, and OthNAmt is the computed, read-only result.
    const othDisplayField = (field, col) => isOthRupeesMode(col) ? `${field}Amt` : field;
    // Display-only sign prefix for the disabled "Oth N Amount" field — shows
    // "-" when that Oth is configured as subtract (AddLess=1), nothing when
    // it's add. Purely cosmetic: never stored, never fed back into calculation.
    const othAmtDisplay = (col, amt) => amt ? `${Boolean(getColRow(col)?.AddLess) ? '-' : ''}${amt}` : '';
    const handleOthChange = (field, col) => (e) => {
        let raw = e.target.value;
        // Numbers only (digits with at most one decimal point) — no letters/special chars
        if (raw !== '' && !/^\d*\.?\d*$/.test(raw)) return;
        if (!isOthRupeesMode(col) && raw !== '') {
            // Percentage mode: clamp to [0, 100]
            const num = Number(raw);
            if (num > 100) raw = '100';
            if (num < 0) raw = '0';
        }
        const targetKey = othDisplayField(field, col);
        setCurrent(prev => {
            const updated = { ...prev, [targetKey]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };
    // Qty/Rate/Disc changing also shifts the base amount Oth1-7 are computed
    // from — reapply them live here too, instead of only on Add/Update Product.
    const handleBaseFieldChange = (field) => (e) => {
        const raw = e.target.value;
        setCurrent(prev => {
            const updated = { ...prev, [field]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };

    // "Enable Convesrion effect in Transaction?" — Confirm applies the pending Unit change plus
    // the Conversion Qty the user entered/accepted, deriving the billed Rate from
    // this row's baseRate (the rate as it stood before any conversion — captured
    // once at product-select time and preserved untouched so it can always be
    // recovered). Cancel reverts the Unit selection back to whatever it was
    // before, so a cancelled popup never leaves the row half-changed.
    const handleConfirmConversionQty = () => {
        if (!pendingUnitChange) return;
        const convQty = Number(conversionQtyInput) || 0;

        if (convQty > 0) {
            const { rate: convertedRate } = calculateConversion(current.baseRate, current.qty, convQty);
            setCurrent(prev => ({
                ...prev,
                UnitId: pendingUnitChange.UnitId,
                unit: pendingUnitChange.unit,
                rate: convertedRate,
                ConversionQty: convQty,
                ConversionRate: prev.baseRate,
            }));
        } else {
            // Invalid/blank conversion qty — treat like Cancel rather than divide by zero.
            setCurrent(prev => ({ ...prev, UnitId: pendingUnitChange.previousUnitId }));
        }

        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    const handleCancelConversionQty = () => {
        if (pendingUnitChange) {
            setCurrent(prev => ({ ...prev, UnitId: pendingUnitChange.previousUnitId }));
        }
        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };


    const handleSelect = async product => {
        // In edit mode, if any row has SO reference, don't allow selecting new products
        if (mode === 'edit' && hasAnySOReference()) {
            setErrors({ global: 'Cannot add new products when SO reference exists in edit mode.' });
            return;
        }

        const matchedUnit = unitOptions.find(opt => {
            if (product.UnitId && String(opt.UnitId) === String(product.UnitId)) return true;
            if (product.Unit && opt.unit?.toLowerCase() === String(product.Unit).toLowerCase()) return true;
            if (product.unit && opt.unit?.toLowerCase() === String(product.unit).toLowerCase()) return true;
            return false;
        });
        const matchedColor = colorOptions.find(opt => opt.name.toLowerCase() === (product.color || '').toLowerCase());
        const matchedSize = sizeOptions.find(opt => opt.name.toLowerCase() === (product.size || '').toLowerCase());
        const tax = parseFloat(product.GST) || 0;
        const taxId = product.TaxId || null;

        // Initialize rate and disc with product defaults
        let rate = Number(product.Rate) === 0 ? '' : Number(product.Rate);
        let disc = Number(product.Discount) === 0 ? '' : Number(product.Discount);
        let MRP = Number(product.MRP) || 0;

        // If "Apply MRP in Sale?" is enabled and product has MRP, calculate rate from MRP
        if (isApplyMRPInSaleEnabled && MRP > 0) {
            console.log('🏷️ Challan_Stepper: Apply MRP in Sale enabled. Calculating rate from MRP:', MRP);
            rate = calculateSaleRateFromMRP(MRP, tax);
        }

        // "Show Item List Partywise in Sale?" — when enabled, this item's Rate/Disc
        // must come strictly from partywiserate for this party, with NO fallback to
        // productmaster's saleRate/SaleDisc.
        if (isShowItemListPartywiseInSaleEnabled && clientData?.clientId) {
            const partywiseData = await getPartywiseRate(product.Id, clientData.clientId);
            if (partywiseData.found) {
                rate = partywiseData.saleRate !== null ? partywiseData.saleRate : '';
                disc = partywiseData.disc !== null ? partywiseData.disc : '';
                console.log('✅ Challan_Stepper: Rate/Disc taken from partywiserate (no productmaster fallback):', rate, disc);
            }
        }

        // Fetch Last Sale Rate if enabled
        if (isLastSaleRateEnabled) {
            console.log('💾 Challan_Stepper: Fetching last sale rate for product:', product.Id, 'party:', clientData?.clientId);
            const lastSaleData = await getLastSaleRate(product.Id, clientData?.clientId);
            if (lastSaleData.rate !== null) {
                rate = lastSaleData.rate;
                console.log('✅ Challan_Stepper: Last sale rate fetched:', rate);
            }
            if (lastSaleData.disc !== null) {
                disc = lastSaleData.disc;
                console.log('✅ Challan_Stepper: Last sale disc fetched:', disc);
            }
        }

        // "Apply Partywise/Price-listwise Disc. in Sale?" — if the item has a
        // price-list entry, use its NewPrice as the Rate; otherwise the existing
        // productmaster-based rate above is left untouched.
        if (isApplyPartywisePriceListDiscInSaleEnabled) {
            const priceListData = await getPriceListRate(product.Id);
            if (priceListData.found && priceListData.newPrice !== null) {
                rate = priceListData.newPrice;
                console.log('✅ Challan_Stepper: Rate taken from pricelistdetails:', rate);
            }

            // Disc now comes from groupwisedisc (matched by this item's ItemGrpId for
            // this party), not clientmaster. If there's no matching group-wise entry,
            // Disc is 0.00 — no fallback to clientmaster or productmaster.
            if (clientData?.clientId) {
                const groupDiscData = await getGroupWiseDisc(product.Id, clientData.clientId);
                disc = groupDiscData.found && groupDiscData.disc !== null ? groupDiscData.disc : 0;
                console.log('✅ Challan_Stepper: Disc taken from groupwisedisc (no fallback):', disc);
            }
        }

        // "Disc Scheme" — Disc is taken from clientmaster.Disc; Oth1/Oth2 from clientmaster.Disc1/Disc2.
        // Oth1 and Oth2 are checked independently: each is filled only if it is
        // enabled, Percentage (not Rupees) and minus (AddLess). Empty/null -> 0.
        let discSchemeOth = null;
        if (isDiscSchemeEnabled && clientData?.clientId) {
            const scheme = await getClientDiscScheme(clientData.clientId);
            disc = scheme.disc || 0;
            const oth1Qualifies = isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && Boolean(getColRow(COL.OTH1)?.AddLess);
            const oth2Qualifies = isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && Boolean(getColRow(COL.OTH2)?.AddLess);
            if (oth1Qualifies || oth2Qualifies) {
                discSchemeOth = {
                    oth1: oth1Qualifies ? String(scheme.disc1 || 0) : '',
                    oth2: oth2Qualifies ? String(scheme.disc2 || 0) : '',
                };
            }
        }

        setCurrent({
            Id: product.Id.toString(),
            productCode: product.itemCode,
            description: product.description,
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product.UnitId || ''),
            unit: matchedUnit ? matchedUnit.unit : (product.Unit || product.unit || ''),
            // "Enable Convesrion effect in Transaction?" — the product's own default Unit/ratio and
            // this row's base rate (as resolved above), preserved untouched so the
            // conversion math and a revert-to-default-Unit can always recover it.
            defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
            convUnitId: product.ConvUnit ? String(product.ConvUnit) : '',
            productConvQty: Number(product.ConvQty) || '',
            baseRate: rate,
            ConversionQty: null,
            ConversionRate: null,
            qty: mode === 'add' ? '' : '',
            dispatchQty: '',
            rate: rate,
            disc: disc,
            tax,
            MRP,
            TaxId: taxId,
            size: matchedSize?.name || '',
            color: matchedColor?.name || '',
            batchNo: '',
            expDate: '',
            serialNo: '',
            amount: '',
            remark: '',
            minLevel: Number(product.minLevel) || null,
            PONo: '',
            PODate: '',
            POQty: '',
            type: '',
            pkg: '',
            freeQty: '',
            per: '',
            oth1: discSchemeOth ? discSchemeOth.oth1 : '',
            oth2: discSchemeOth ? discSchemeOth.oth2 : '',
            oth3: '',
            oth4: '',
            oth5: '',
            oth6: '',
            oth7: '',
            oth1Amt: '',
            oth2Amt: '',
            oth3Amt: '',
            oth4Amt: '',
            oth5Amt: '',
            oth6Amt: '',
            oth7Amt: '',
            Pf: '',
            PfAmt: '',
            Insu: '',
            InsuAmt: '',
            Freight: '',
            FreightAmt: '',
            DiscAmt: '',
            SOQty: '',
            UTGST: '0.00',
            GSTCess: '0.00',
            GSTCEssAmt: '0.00',
            GSTOth: '0.00',
            GSTEduCess: '0.00',
            GSTEducessAmt: '0.00',
            CGSTAmt: '0.00',
            SGSTAmt: '0.00',
            IGSTAmt: '0.00',
            TaxableAmt: '0.00',
            TCS: '0.00',
            TCSAmt: '0.00',
            TDS: '0.00',
            TDSAmt: '0.00',
            ex4: '',
            ex5: '',
            exQty6: '',
            serialNo: ''
        });
        // setEditIndex(null);
        setErrors({});
    };

    const addProduct = async () => {

        const hasSORef =
            (current.SOID || current.soId) &&
            (current.SODtsID || current.soDtsID);

        // In edit mode, if any row has SO reference, don't allow adding/updating products
        if (mode === 'edit' && hasAnySOReference()) {
            setErrors({ global: 'Cannot add/update products when SO reference exists in edit mode.' });
            return;
        }

        const errs = {};
        const messages = new Set();
        const requiredFields = ['productCode', 'description', 'UnitId', 'dispatchQty', 'tax'];

         // GST validation
        if (!current.TaxId) {
            errs.TaxId = true;
            messages.add('Please select GST before adding product.');
        }

        let missingRequired = false;
        requiredFields.forEach(field => {
            if (!current[field] && current[field] !== 0) {
                errs[field] = 'Required';
                missingRequired = true;
            }
        });

        if (missingRequired) {
            messages.add('All fields are required.');
        }

        if (mode === 'edit' && hasSORef) {
            if (!current.qty || Number(current.qty) <= 0) {
                errs.qty = 'Must be > 0';
                messages.add('Qty must be greater than 0');
            }
        }

        if (!(mode === 'edit' && !hasSORef)) {
            if (Number(current.dispatchQty) <= 0) {
                errs.dispatchQty = 'Must be > 0';
                messages.add('Dispatch Qty must be greater than 0');
            }
        }

        if (current.tax < 0) {
            errs.tax = 'Cannot be negative';
            messages.add('Tax cannot be negative');
        }

        const product = productMap.get(current.Id);
        if (!(mode === 'edit' && !hasSORef)) {
            const { isValid } = validateDispatchQty(
                current.dispatchQty,
                current.qty,
                current.minLevel,
                product?.minLevel
            );

            if (!isValid) {
                errs.dispatchQty = `Dispatch Qty must be valid`;
                messages.add(errs.dispatchQty);
            }
        }

        if (messages.size > 0) {
            errs.global = Array.from(messages);
            setErrors(errs);
            return;
        }

        const safeDisc =
            current.disc === '' || current.disc == null
                ? 0
                : Number(current.disc);

        const safeRate =
            current.rate === '' || current.rate == null
                ? 0
                : Number(current.rate);

        // Negative/Zero Stock validation check - block if negative/zero and configure is enabled
        console.log('🚫 Challan_Stepper: Checking if product has negative or zero stock');
        const zeroStockValidation = await validateNegativeZeroStock(current.Id);
        console.log('🚫 Challan_Stepper: Zero stock validation result:', zeroStockValidation);

        if (zeroStockValidation.isBlocked) {
            console.log('❌ Challan_Stepper: Product is blocked - stock is zero or negative');
            setZeroStockErrorData(zeroStockValidation);
            setZeroStockErrorOpen(true);
            return;
        }

        if (zeroStockValidation.shouldShowWarning) {
            console.log('⚠️ Challan_Stepper: Showing zero stock warning - user can choose to add anyway');
            const confirmed = await new Promise((resolve) => {
                setZeroStockErrorData(zeroStockValidation);
                setZeroStockErrorOpen(true);
                setStockConfirmResolve(() => resolve);
            });
            console.log('✅ Challan_Stepper: User response to zero stock warning:', confirmed);
            if (!confirmed) {
                console.log('❌ Challan_Stepper: User cancelled - not adding product');
                return;
            }
            console.log('✅ Challan_Stepper: User chose to add anyway - proceeding');
        } else {
            console.log('✅ Challan_Stepper: No zero stock warning needed - proceeding');
        }

        // Min Level Stock validation check
        const dispatchQty = Number(current.dispatchQty) || 0;
        console.log('📋 Challan_Stepper: About to validate min level stock for item:', { itemId: current.Id, dispatchQty, L_No });
        const stockValidation = await validateMinLevel(current.Id, dispatchQty, L_No);
        console.log('📊 Challan_Stepper: Stock validation result:', stockValidation);

        if (stockValidation.shouldShowWarning) {
            console.log('⚠️ Challan_Stepper: Showing min level stock warning dialog');
            const confirmed = await new Promise((resolve) => {
                setStockWarningData(stockValidation);
                setStockConfirmResolve(() => resolve);
                setStockWarningOpen(true);
            });
            console.log('✅ Challan_Stepper: User response to min level warning:', confirmed);
            if (!confirmed) {
                console.log('❌ Challan_Stepper: User cancelled - not adding product');
                return;
            }
        } else {
            console.log('✅ Challan_Stepper: No min level stock warning needed - proceeding');
        }

        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        const baseAmount = calcAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc, pkg: current.pkg });
        // Oth1→Oth7 are applied on top of this base amount before the row is committed,
        // so Add/Update Product always carries the Oth-adjusted amount, not the raw base.
        const { taxableAmt: amount, amounts: othAmounts } = applyOthCharges(baseAmount, current);
        const taxAmount = Number((amount * ((Number(current.tax) || 0) / 100)).toFixed(2));
        const grossBase = getAmountCalcSafe(Number(current.dispatchQty) || 0, safeRate, current.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
        const discAmt = Number((grossBase * (safeDisc / 100)).toFixed(2));

        const row = {
            ...current,
            ...othAmounts,
            productId: current.Id,
            UnitId: current.UnitId,
            qty: Number(current.qty),
            rate: safeRate,
            disc: safeDisc,
            DiscAmt: discAmt,
            tax: Number(current.tax) || 0,
            remark: current.remark || '',
            GST: `${current.tax}%`,
            CGST: isSameState ? (current.tax / 2).toString() : '0',
            SGST: isSameState ? (current.tax / 2).toString() : '0',
            IGST: isSameState ? '0' : current.tax.toString(),
            UTGST: current.UTGST || '0',
            GSTCess: current.GSTCess || '0',
            saleRate: current.saleRate || '0',
            saleDiscount: current.saleDiscount || '0',
            amount,
            taxAmount,
            taxableAmount: amount,
            // No SO reference for manually added products
            soId: current.SOID || current.SOId || null,
            soDtsID: current.soDtsID || null,
            SOID: current.SOID || current.SOId || null,
            SODtsID: current.soDtsID || null,
            TransType: current.TransType || 100,
        };

        // Check if productCode already exists in rows
        const existingRowIndex = rows.findIndex(r => r.productCode === current.productCode);

        // if (existingRowIndex !== -1 && editIndex == null) {
        //     // Merge with existing row
        //     setRows(prev => prev.map((r, i) => {
        //         if (i === existingRowIndex) {
        //             const mergedQty = Number(r.qty) + Number(current.qty);
        //             const mergedDispatchQty = Number(r.dispatchQty) + Number(current.dispatchQty);
        //             return {
        //                 ...r,
        //                 // Update fields from current input
        //                 UnitId: current.UnitId,
        //                 unit: current.unit,
        //                 qty: mergedQty,
        //                 dispatchQty: mergedDispatchQty,
        //                 rate: safeRate,
        //                 disc: Number(current.disc) || 0,
        //                 tax: Number(current.tax) || 0,
        //                 GST: `${current.tax}%`,
        //                 CGST: isSameState ? (current.tax / 2).toString() : '0',
        //                 SGST: isSameState ? (current.tax / 2).toString() : '0',
        //                 IGST: isSameState ? '0' : current.tax.toString(),
        //                 amount: calcAmount({
        //                     dispatchQty: mergedDispatchQty,
        //                     rate: safeRate,
        //                     disc: Number(current.disc)
        //                 }),
        //                 taxAmount: calcTaxAmount({
        //                     dispatchQty: mergedDispatchQty,
        //                     rate: safeRate,
        //                     disc: Number(current.disc),
        //                     tax: Number(current.tax)
        //                 }),
        //                 taxableAmount: calcAmount({
        //                     dispatchQty: mergedDispatchQty,
        //                     rate: safeRate,
        //                     disc: Number(current.disc)
        //                 }),
        //                 // Preserve existing fields if not provided in current
        //                 size: current.size || r.size || '',
        //                 color: current.color || r.color || '',
        //                 batchNo: current.batchNo || r.batchNo || '',
        //                 expDate: current.expDate || r.expDate || '',
        //                 serialNo: current.serialNo || r.serialNo || '',
        //                 remark: current.remark || r.remark || '',
        //                 minLevel: current.minLevel != null ? Number(current.minLevel) : r.minLevel,
        //                 SOID: r.SOID || null,
        //                 SODtsID: r.SODtsID || null,
        //                 srNo: r.srNo,
        //                 id: r.srNo
        //             };
        //         }
        //         return r;
        //     }));
        // } else {
        //     // Add new row or update edited row
        //     row.srNo = editIndex != null ? rows[editIndex].srNo : nextSrNo;
        //     row.id = editIndex != null ? rows[editIndex].srNo : nextSrNo;
        //     if (editIndex != null) {
        //         setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
        //     } else {
        //         setRows((prev) => [row, ...prev]);
        //         setNextSrNo(prev => prev + 1);
        //     }
        //     setIsEditingMode(false);
        // }

        if (editIndex != null) {
            setRows(prev => prev.map((r, i) => i === editIndex ? { ...row, srNo: rows[editIndex].srNo } : r));
        } else {
            row.srNo = nextSrNo;
            setRows(prev => [row, ...prev]);
            setNextSrNo(prev => prev + 1);
        }

        setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : '', dispatchQty: '', rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, TaxId: null, TransType: 100, PONo: '', PODate: '', POQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: '', oth2: '', oth3: '', oth4: '', oth5: '', oth6: '', oth7: '', oth1Amt: '', oth2Amt: '', oth3Amt: '', oth4Amt: '', oth5Amt: '', oth6Amt: '', oth7Amt: '', Pf: '', PfAmt: '', Insu: '', InsuAmt: '', Freight: '', FreightAmt: '', DiscAmt: '', SOQty: '', UTGST: '0.00', GSTCess: '0.00', GSTCEssAmt: '0.00', GSTOth: '0.00', GSTEduCess: '0.00', GSTEducessAmt: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TCS: '0.00', TCSAmt: '0.00', TDS: '0.00', TDSAmt: '0.00', ex4: '', ex5: '', exQty6: '', serialNo: '', defaultUnitId: '', convUnitId: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null, MRP: 0 });
        setErrors({});
        setEditIndex(null);
        setOriginalEditQty(null);
        setIsEditingMode(false);

        // Focus on Product Code field after adding product (not after updating)
        if (editIndex == null) {
            setTimeout(() => {
                productCodeRef.current?.focus?.();
            }, 0);
        }
    };

    const editRow = idx => {
        const row = rows[idx];

        // In edit mode, if this row has SO reference, don't allow editing
        if (
            mode === 'edit' &&
            (rowHasSOReference(row) || rowIsInvoiceLocked(row))
        ) {
            setErrors({ global: 'Cannot edit this product. Invoice already created.' });
            return;
        }

        const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) ||
            unitOptions.find(u => String(u.UnitId) === String(row.unit)) ||
            unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

        // This row's Qty/Rate/Pkg/Disc are about to be loaded into `current` from
        // the DB values — skip the next live-calculation pass so it doesn't
        // immediately overwrite the stored amount before the user edits anything.
        skipNextCalcRef.current = true;

        setCurrent({
            ...row,
            rate: Number(row.rate) === 0 ? '' : row.rate,
            disc: Number(row.disc) === 0 ? '' : row.disc,
            dispatchQty: row.dispatchQty || '',
            minLevel: row.minLevel,
            UnitId: row.UnitId || null,
            TaxId: row.TaxId || null,
            PONo: row.PONo || row.refNo || '',
            PODate: row.PODate || row.refDate || '',
            POQty: row.POQty || row.refQty || '',
            type: row.type || '',
            size: row.size || '',
            color: row.color || '',
            batchNo: row.batchNo || '',
            expDate: row.expDate || '',
            pkg: row.pkg || '',
            freeQty: row.freeQty || '',
            per: row.per || '',
            oth1: row.oth1 || '',
            oth2: row.oth2 || '',
            oth3: row.oth3 || '',
            oth4: row.oth4 || '',
            oth5: row.oth5 || '',
            oth6: row.oth6 || '',
            oth7: row.oth7 || '',
            oth1Amt: row.oth1Amt || '',
            oth2Amt: row.oth2Amt || '',
            oth3Amt: row.oth3Amt || '',
            oth4Amt: row.oth4Amt || '',
            oth5Amt: row.oth5Amt || '',
            oth6Amt: row.oth6Amt || '',
            oth7Amt: row.oth7Amt || '',
            Pf: row.Pf || '',
            PfAmt: row.PfAmt || '',
            Insu: row.Insu || '',
            InsuAmt: row.InsuAmt || '',
            Freight: row.Freight || '',
            FreightAmt: row.FreightAmt || '',
            DiscAmt: row.DiscAmt || '',
            SOQty: row.SOQty || '',
            UTGST: row.UTGST || row.UTGSTAmt || '0.00',
            GSTCess: row.GSTCess || '0.00',
            GSTCEssAmt: row.GSTCEssAmt || '0.00',
            GSTOth: row.GSTOth || row.gOth10 || '0.00',
            GSTEduCess: row.GSTEduCess || '0.00',
            GSTEducessAmt: row.GSTEducessAmt || '0.00',
            CGSTAmt: row.CGSTAmt || '0.00',
            SGSTAmt: row.SGSTAmt || '0.00',
            IGSTAmt: row.IGSTAmt || '0.00',
            TaxableAmt: row.TaxableAmt || '0.00',
            TCS: row.TCS || '0.00',
            TCSAmt: row.TCSAmt || '0.00',
            TDS: row.TDS || '0.00',
            TDSAmt: row.TDSAmt || '0.00',
        });

        setEditIndex(idx);
        setOriginalEditQty(Number(row.qty) || 0);

        setIsEditingMode(true);
    };

    const deleteRow = idx => {
        const row = rows[idx];

        // In edit mode, if this row has SO reference, don't allow deleting
        if (mode === 'edit' && rowHasSOReference(row)) {
            setErrors({ global: 'Cannot delete products with SO reference in edit mode.' });
            return;
        }

        setRows(prev => prev.filter((_, i) => i !== idx));
        if (idx === editIndex) {
            setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : '', dispatchQty: '', rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, TaxId: null, TransType: 100, PONo: '', PODate: '', POQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: '', oth2: '', oth3: '', oth4: '', oth5: '', oth6: '', oth7: '', oth1Amt: '', oth2Amt: '', oth3Amt: '', oth4Amt: '', oth5Amt: '', oth6Amt: '', oth7Amt: '', Pf: '', PfAmt: '', Insu: '', InsuAmt: '', Freight: '', FreightAmt: '', DiscAmt: '', SOQty: '', UTGST: '0.00', GSTCess: '0.00', GSTCEssAmt: '0.00', GSTOth: '0.00', GSTEduCess: '0.00', GSTEducessAmt: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TCS: '0.00', TCSAmt: '0.00', TDS: '0.00', TDSAmt: '0.00', ex4: '', ex5: '', exQty6: '', serialNo: '', defaultUnitId: '', convUnitId: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null, MRP: 0 });
            setEditIndex(null);
            setErrors({});
            setOriginalEditQty(null);
        }
    };

    const handleNext = () => {
        if (rows.length === 0) {
            setErrors({ global: 'Add at least one product' });
            return;
        }

        if (hasInvalidDispatchQty()) {
            setErrors({ global: 'Correct invalid dispatch quantities before proceeding' });
            return;
        }

        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        const payloadRows = rows.map(r => {
            const dispatchQty = Number(r.dispatchQty) || 0;
            const baseTaxableAmount = calcAmount(r);
            // Oth1→Oth7 are re-applied on top of the base amount here too, so the
            // final submit payload always carries the Oth-adjusted amount (matching
            // what Add/Update Product already computed) instead of silently
            // reverting to the raw dispatchQty*rate*disc base.
            const { taxableAmt: taxableAmount, amounts: othAmountsFinal } = applyOthCharges(baseTaxableAmount, r);
            const taxAmount = Number((taxableAmount * ((Number(r.tax) || 0) / 100)).toFixed(2));
            const cgstRate = Number(r.CGST) || (isSameState ? Number(r.tax) / 2 : 0);
            const sgstRate = Number(r.SGST) || (isSameState ? Number(r.tax) / 2 : 0);
            const igstRate = Number(r.IGST) || (isSameState ? 0 : Number(r.tax));
            const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
            const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
            const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

            // ── Determine what goes into qty vs dispQty per mode ──────────────
            //
            // add mode:
            //   The "Qty" field in the UI is bound to dispatchQty (the user enters
            //   how many units to dispatch). There is no separate SO qty concept.
            //   → qty (DB column) = null/0 — no SO order qty exists
            //   → dispQty          = what the user typed
            //
            // ref mode:
            //   Rows come pre-loaded from an SO. r.originalQty = SO qty,
            //   dispatchQty = what the user chose to dispatch now.
            //   → qty   = original SO qty (preserved)
            //   → dispQty = user-chosen dispatch qty
            //
            // edit mode:
            //   Row already exists in DB. r.qty = stored SO/order qty,
            //   dispatchQty = current dispatched qty.
            //   → qty   = original stored qty (unchanged)
            //   → dispQty = current dispatchQty

            let qtyPayload;

            if (mode === 'add') {
                // In add mode, qty has no meaning (no SO reference).
                // Send 0 (or null) so the backend stores only dispQty.
                qtyPayload = 0;
            } else if (mode === 'ref') {
                // Preserve the original SO qty
                qtyPayload = r.originalQty !== undefined
                    ? Number(r.originalQty)
                    : Number(r.qty) || 0;
            } else {
                // edit mode — keep whatever qty was stored in DB
                qtyPayload = Number(r.qty) || 0;
            }

            // origQty / origDispatchQty — used only for rehydration on step-back
            let origQty, origDispatchQty;
            if (mode === 'ref' && r.originalQty !== undefined) {
                origQty = String(r.originalQty);
                origDispatchQty = String(r.challanDispatchedQty || 0);
            } else if (mode === 'ref') {
                origQty = String(Number(r.qty) - dispatchQty || '');
                origDispatchQty = String(dispatchQty);
            } else {
                origQty = String(qtyPayload);
                origDispatchQty = '0';
            }

            return {
                productId: r.productId,
                productCode: r.productCode,
                description: r.description,
                UnitId: r.UnitId,
                unit: r.unit,

                origQty,
                origDispatchQty,

                // ✅ KEY FIX: qty and dispatchQty are now distinct per mode
                qty: String(qtyPayload),   // SO/order qty — 0 in add mode
                dispatchQty: String(dispatchQty), // what was actually dispatched

                // "Enable Convesrion effect in Transaction?" — ConversionQty/ConversionRate mirror
                // salechallandetails' columns 1:1 (null on a normal, non-converted
                // row). The backend's manageStockEntry divides dispatchQty by
                // ConversionQty itself, so no separate stockQty needs computing here.
                ConversionQty: r.ConversionQty != null ? Number(r.ConversionQty) : null,
                ConversionRate: r.ConversionRate != null ? Number(r.ConversionRate) : null,

                rate: r.rate.toFixed(2),
                MRP: Number(r.MRP) || 0,
                disc: r.disc.toFixed(2),
                CGST: cgstRate.toFixed(2),
                CGSTAmt: cgstAmt,
                SGST: sgstRate.toFixed(2),
                SGSTAmt: sgstAmt,
                IGST: igstRate.toFixed(2),
                IGSTAmt: igstAmt,
                TaxId: r.TaxId || 31,
                tax: Number(r.tax),
                remark: r.remark || '',
                amount: taxableAmount.toFixed(2),
                taxAmount: taxAmount.toFixed(2),
                SOID: r.SOID || r.soId || null,
                SODtsID: r.SODtsID || r.soDtsID || null,
                challanDtsID: r.challanDtsID || null,
                challanID: r.challanID || null,
                PONo: r.PONo || r.refNo || null,
                PODate: r.PODate || r.refDate || null,
                POQty: r.POQty || r.refQty || null,
                type: r.type || null,
                size: r.size || null,
                color: r.color || null,
                freeQty: r.freeQty || null,
                per: r.per || null,
                pkg: r.pkg || null,
                oth1: r.oth1 || null,
                oth1Amt: othAmountsFinal.oth1Amt,
                oth2: r.oth2 || null,
                oth2Amt: othAmountsFinal.oth2Amt,
                oth3: r.oth3 || null,
                oth3Amt: othAmountsFinal.oth3Amt,
                oth4: r.oth4 || null,
                oth4Amt: othAmountsFinal.oth4Amt,
                oth5: r.oth5 || null,
                oth5Amt: othAmountsFinal.oth5Amt,
                oth6: r.oth6 || null,
                oth6Amt: othAmountsFinal.oth6Amt,
                oth7: r.oth7 || null,
                oth7Amt: othAmountsFinal.oth7Amt,
                Pf: r.Pf || null,
                PfAmt: r.PfAmt || null,
                Insu: r.Insu || null,
                InsuAmt: r.InsuAmt || null,
                Freight: r.Freight || null,
                FreightAmt: r.FreightAmt || null,
                DiscAmt: r.DiscAmt || null,
                SOQty: r.SOQty || null,
                GSTCEssAmt: r.GSTCEssAmt || null,
                GSTCess: r.GSTCess || null,
                GSTOth: r.GSTOth || r.gOth10 || null,
                UTGSTAmt: r.UTGSTAmt || r.UTGST || null,
                GSTEduCess: r.GSTEduCess || null,
                GSTEducessAmt: r.GSTEducessAmt || null,
                TCS: r.TCS || null,
                TCSAmt: r.TCSAmt || null,
                TDS: r.TDS || null,
                TDSAmt: r.TDSAmt || null,
                ex4: r.ex4 || null,
                ex5: r.ex5 || null,
                exQty6: r.exQty6 || null,
                serialNo: r.serialNo || null,
                TransType: r.TransType || 100,
            };
        });

        const summarySection = {
            totalProducts: rows.length,
            totalDispatchQty: rows.reduce((sum, r) => sum + Number(r.dispatchQty), 0),
            products: rows.map(r => ({
                productCode: r.productCode,
                description: r.description,
                dispatchQty: r.dispatchQty.toString(),
                amount: calcAmount(r).toFixed(2),
                taxAmount: calcTaxAmount(r).toFixed(2),
            })),
        };

        // Additional Charges: charges saved in UserDefineColumns with ColToBeAsk=1
        // (i.e. present in `additionalCharges`, sourced from UserDefineContext) are
        // folded into the challan payload — Adc{SrNo}Amt/Adc{SrNo}TaxId in summary
        // for all 5 fixed slots, plus one pseudo item row per SELECTED charge
        // (TransType 200-204, SrNo 20000-20004) appended to tableData.
        // When a charge's Tax is disabled, its TaxId is resolved to the taxmaster
        // row where GST = 0 (found via gsts, whose `value` doubles as the % — same
        // pattern already used elsewhere in this file, e.g. parseFloat(opt.value)).
        const zeroTaxId = gsts.find(g => parseFloat(g.value) === 0)?.Id ?? null;

        const additionalChargeSummary = {};
        const additionalChargeItems = [];
        for (let slot = 1; slot <= 5; slot++) {
            const charge = additionalCharges.find(c => Number(c.SrNo) === slot);
            if (!charge) {
                additionalChargeSummary[`Adc${slot}Amt`] = 0;
                additionalChargeSummary[`Adc${slot}TaxId`] = null;
                continue;
            }
            const key = charge.TransType;
            const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
            const amount = Number(input.amount) || 0;

            // Skip charge rows with 0 amount (user didn't enter a value)
            if (amount === 0) {
                additionalChargeSummary[`Adc${slot}Amt`] = 0;
                additionalChargeSummary[`Adc${slot}TaxId`] = null;
                continue;
            }

            const { taxPercent, taxAmount, finalAmount } = getChargeFinalAmounts(charge, input);
            const taxId = charge.TaxEnabled ? (input.taxId ?? null) : zeroTaxId;

            additionalChargeSummary[`Adc${slot}Amt`] = amount;
            additionalChargeSummary[`Adc${slot}TaxId`] = taxId;

            const chargeItemId = getChargeItemId('CHAL', slot);
            additionalChargeItems.push({
                Id: chargeItemId,
                productId: chargeItemId,
                productCode: charge.ChargeName || '',
                description: charge.ChargeName || '',
                UnitId: null,
                unit: '',

                origQty: '0',
                origDispatchQty: '0',

                // Additional Charge rows have no real SO/order qty, but the
                // backend's dispatch-quantity validation requires a valid number
                // (NaN/negative is rejected) and salechallandetails.dispQty stores
                // it as-is — qty/dispatchQty: '1' satisfies both, same string
                // shape as payloadRows above.
                qty: '1',
                dispatchQty: '1',

                rate: amount.toFixed(2),
                disc: (0).toFixed(2),
                CGST: (isSameState ? taxPercent / 2 : 0).toFixed(2),
                CGSTAmt: (isSameState ? taxAmount / 2 : 0).toFixed(2),
                SGST: (isSameState ? taxPercent / 2 : 0).toFixed(2),
                SGSTAmt: (isSameState ? taxAmount / 2 : 0).toFixed(2),
                IGST: (isSameState ? 0 : taxPercent).toFixed(2),
                IGSTAmt: (isSameState ? 0 : taxAmount).toFixed(2),
                TaxId: taxId,
                tax: Number(taxPercent.toFixed(2)),
                remark: '',
                amount: amount.toFixed(2),
                taxAmount: taxAmount.toFixed(2),
                SOID: null,
                SODtsID: null,
                challanDtsID: null,
                challanID: null,
                PONo: null,
                PODate: null,
                POQty: null,
                type: null,
                size: null,
                color: null,
                freeQty: null,
                per: null,
                pkg: null,
                oth1: null,
                oth1Amt: null,
                oth2: null,
                oth2Amt: null,
                oth3: null,
                oth3Amt: null,
                oth4: null,
                oth4Amt: null,
                oth5: null,
                oth5Amt: null,
                oth6: null,
                oth6Amt: null,
                oth7: null,
                oth7Amt: null,
                Pf: null,
                PfAmt: null,
                Insu: null,
                InsuAmt: null,
                Freight: null,
                FreightAmt: null,
                DiscAmt: null,
                SOQty: null,
                GSTCEssAmt: '0.00',
                GSTCess: '0.00',
                GSTOth: '0.00',
                UTGSTAmt: '0.00',
                GSTEduCess: '0.00',
                GSTEducessAmt: '0.00',
                TCS: null,
                TCSAmt: null,
                TDS: null,
                TDSAmt: null,
                ex4: null,
                ex5: null,
                exQty6: null,
                serialNo: '',

                // Extra fields needed only by the charges mechanism (not part of
                // the normal payloadRows shape): TaxableAmt (tax-inclusive final
                // amount), configData/_isNew/etc. for row bookkeeping, and the
                // fixed SrNo/TransType identifiers driving the backend's
                // TransType-aware SrNo override (see dispatchController.js /
                // saleInvoiceController.js).
                TaxableAmt: Number(finalAmount.toFixed(2)),
                batchNo: '',
                expDate: null,
                serialNo: '',
                configData: [],
                _isNew: true,
                configType: null,
                applyBatchNo: 0,
                applySerialNo: 0,
                warrantyMonths: null,
                expiryDays: null,
                srNo: 19999 + slot,
                gross: amount,
                SrNo: 19999 + slot,
                TransType: 199 + slot,
            });
        }

        const finalTableData = [...payloadRows, ...additionalChargeItems];
        const payload = {
            tableData: finalTableData,
            summary: {
                ...totals,
                basic: Number(totals.basic),
                grossBasic: Number(totals.grossBasic),
                cgst: Number(totals.cgst) + Number(chargesSummary.cgst || 0),
                sgst: Number(totals.sgst) + Number(chargesSummary.sgst || 0),
                igst: Number(totals.igst) + Number(chargesSummary.igst || 0),
                total: Number(totals.total),
                ...additionalChargeSummary
            },
            summarySection,
            chargeInputs: chargeInputs
        };

        console.log('📤 PAYLOAD SENT TO NEXT:', JSON.stringify(payload, null, 2));

        onNext(payload);
    };

    const formatINR = val => Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const columns = [
        { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
        {
            field: 'product', headerName: 'Product', flex: 1, sortable: true, filterable: true,
            renderCell: params => {
                const { productCode, description, unit, tax, CGST, SGST, IGST, size, color, batchNo, expDate, serialNo, remark, SONumber, SODate } = params.row;
                const isSameState = state?.toLowerCase() === compState?.toLowerCase();
                const taxableAmount = calcAmount(params.row);
                const cgstRate = Number(CGST) || (isSameState ? Number(tax) / 2 : 0);
                const sgstRate = Number(SGST) || (isSameState ? Number(tax) / 2 : 0);
                const igstRate = Number(IGST) || (isSameState ? 0 : Number(tax));
                const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
                const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
                const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);



                // Check if this row has SO reference for styling
                const hasSORef = mode === 'edit' && rowHasSOReference(params.row);

                return (
                    <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            <Tooltip title={mode === 'edit' && rowHasSOReference(params.row) ? 'This Challan is created by reference.' : ''} arrow disableHoverListener={!(mode === 'edit' && rowHasSOReference(params.row))} >
                                <span>
                                    <Typography variant="body2" fontWeight="bold" component="div"
                                        sx={{ cursor: mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row)) ? 'not-allowed' : 'pointer', color: mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row)) ? themeColors.neutral.muted : colors.primary.main, textDecoration: mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row)) ? 'none' : 'underline', fontSize: '0.85rem' }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            if (!(mode === 'edit' && rowHasSOReference(params.row))) {
                                                editRow(params.row.index);
                                            }
                                        }}
                                    >
                                        {productCode}
                                    </Typography>
                                </span>
                            </Tooltip>


                            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                                {description}
                            </Typography>
                        </Box>
                        {(isColVisible(COL.UNIT) || isColVisible(COL.TAX_CODE)) && (
                            <Typography variant="caption" display="block">
                                {isColVisible(COL.UNIT) && `Unit: ${unit || 'N/A'}`}
                                {isColVisible(COL.UNIT) && isColVisible(COL.TAX_CODE) && ' | '}
                                {isColVisible(COL.TAX_CODE) && `GST: ${tax}%`}
                            </Typography>
                        )}
                        {(isSameState ? (isColVisible(COL.SGST) || isColVisible(COL.CGST)) : isColVisible(COL.IGST)) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {isSameState
                                    ? [
                                        isColVisible(COL.SGST) && `SGST: ₹${formatINR(sgstAmt)}`,
                                        isColVisible(COL.CGST) && `CGST: ₹${formatINR(cgstAmt)}`,
                                    ].filter(Boolean).join(' + ')
                                    : `IGST: ₹${formatINR(igstAmt)}`}
                            </Typography>
                        )}
                        {(size || color) && (<Typography variant="caption" display="block"> {size && isColVisible(COL.SIZE) && `Size: ${size}`} {color && isColVisible(COL.COLOR) && `| Color: ${color}`} </Typography>)}
                        {((batchNo && isColVisible(COL.BATCH_NO)) || (expDate && isColVisible(COL.EXP_DATE)) || serialNo) && (
                            <Typography variant="caption" display="block">
                                {batchNo && isColVisible(COL.BATCH_NO) && `Batch: ${batchNo}`}
                                {expDate && isColVisible(COL.EXP_DATE) && ` | Exp: ${expDate}`}
                            </Typography>
                        )}
                        {remark && isColVisible(COL.REMARK) && (<Typography variant="caption" display="block" color="text.secondary"> Remark: {remark} </Typography>)}
                        {OTH_FIELDS.some(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)]) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {OTH_FIELDS
                                    .filter(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)])
                                    .map(({ field, col }) => {
                                        const rupees = isOthRupeesMode(col);
                                        const displayVal = params.row[othDisplayField(field, col)];
                                        const amt = params.row[`${field}Amt`];
                                        // Display-only: prefix with "-" when this Oth is configured as
                                        // subtract (AddLess=1) in UserDefineColumns — never "+", purely
                                        // cosmetic, doesn't touch stored values or calculations.
                                        const sign = Boolean(getColRow(col)?.AddLess) ? '-' : '';
                                        return rupees
                                            ? `${getColLabel(col, field)}: ${sign}₹${formatINR(displayVal)}`
                                            : `${getColLabel(col, field)}: ${displayVal}%${amt ? ` (${sign}₹${formatINR(amt)})` : ''}`;
                                    })
                                    .join(' | ')}
                            </Typography>
                        )}
                        {(SONumber || SODate) && (
                            <Typography variant="caption" display="block" color='blue'>
                                {SONumber && `OrderNo: ${SONumber}`}
                                {SODate && ` | Date: ${SODate}`}
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        { field: 'qty', headerName: 'SO Qty', width: 60, align: 'center', headerAlign: 'center' },
        {
            field: 'dispatchQty',
            headerName: 'Dispatch Qty',
            width: 100,
            align: 'center',
            headerAlign: 'center',
            renderCell: params => {
                const product = productMap.get(params.row.productId);
                const minLevel = params.row.minLevel === null ? Infinity : Number(params.row.minLevel) || Number(product?.minLevel) || Infinity;
                const hasSORef = params.row.SOID || params.row.soId ? (params.row.SODtsID || params.row.soDtsID) : false;
                // 🔥 FINAL LOCK CONDITION
                const isDispatchLocked =
                    mode === 'edit' &&
                    (
                        hasSORef  // If Challan exists → lock
                    );

                const soQty = Number(params.row.qty) || 0;

                let limit;

                if (mode === 'add') {
                    // In add mode → only minLevel matters
                    limit = minLevel;
                }
                else if (mode === 'edit' && hasSORef) {
                    // Edit mode with SO → restrict by SO qty
                    limit = Math.min(soQty, minLevel);
                }
                else if (mode === 'ref') {
                    limit = Math.min(soQty, minLevel);
                }
                else {
                    limit = minLevel;
                }

                const { isValid, correctedValue } =
                    mode === 'edit' && !hasSORef
                        ? { isValid: true, correctedValue: params.row.dispatchQty } // skip validation
                        : validateDispatchQty(
                            params.row.dispatchQty,
                            params.row.qty,
                            minLevel
                        );

                return (
                    <TextField
                        type="number"
                        size="small"
                        value={params.row.dispatchQty}
                        inputProps={{
                            min: 0,
                            max: limit,
                            step: 'any'
                        }}
                        disabled={isDispatchLocked}
                        sx={{
                            width: 80,
                            '& .MuiOutlinedInput-root': {
                                height: 38,
                                backgroundColor: hasSORef ? themeColors.neutral.surfaceMuted : 'inherit',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: isValid ? undefined : 'red'
                            },
                        }}
                        onChange={e => {

                            // Lock only in EDIT mode
                            if (mode === 'edit' && hasSORef) return;

                            const raw = e.target.value;

                            // Allow empty while typing
                            if (raw === "") {
                                setRows(prev => prev.map((r, i) => i === params.row.index ? { ...r, dispatchQty: "" } : r));
                                return;
                            }

                            const v = Number(raw);

                            setRows(prev => prev.map((r, i) => i === params.row.index ? { ...r, dispatchQty: v } : r));
                        }}
                        onBlur={() => {
                            if (hasSORef) return;

                            let v = Number(params.row.dispatchQty);

                            if (!(mode === 'edit' && !hasSORef)) {
                                if (!(v > 0) || v > limit) {
                                    v = correctedValue;
                                }
                            }

                            const updatedAmount = calcAmount({
                                dispatchQty: v,
                                rate: params.row.rate,
                                disc: params.row.disc,
                                pkg: params.row.pkg
                            });

                            const updatedTaxAmount = calcTaxAmount({
                                dispatchQty: v,
                                rate: params.row.rate,
                                disc: params.row.disc,
                                tax: params.row.tax,
                                pkg: params.row.pkg
                            });

                            setRows(prev =>
                                prev.map((r, i) =>
                                    i === params.row.index
                                        ? {
                                            ...r,
                                            dispatchQty: v,
                                            amount: updatedAmount,
                                            taxAmount: updatedTaxAmount,
                                            taxableAmount: updatedAmount
                                        }
                                        : r
                                )
                            );
                        }}
                    />
                );
            },
        },
        { field: 'rate', headerName: 'Rate', width: 90, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
        {
            field: 'disc', headerName: 'Disc', width: 50, align: 'center', headerAlign: 'center',
            renderHeader: () => (
                <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
                    <Typography variant="body2">Disc</Typography>
                    <Typography variant="caption" color="text.secondary">(%)</Typography>
                </Box>
            ),
        },
        { field: 'amount', headerName: 'Amount ₹', width: 90, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.amount || 0))}` },
        {
            width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
            renderCell: params => {
                // Check if this row has SO reference - if so, disable delete in edit mode
                const hasSORef =
                    mode === 'edit' && (rowHasSOReference(params.row) || rowIsInvoiceLocked(params.row));

                return (
                    <IconButton
                        size="small"
                        onClick={() => deleteRow(params.row.index)}
                        color="error"
                        disabled={hasSORef || rowIsInvoiceLocked(params.row)}
                        sx={{ opacity: hasSORef ? 0.3 : 1 }}
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                );
            },
        },
    ];

    const isAddProductDisabled = () => {
        if (hasInvalidDispatchQty()) return true;

        // 🔥 Disable only when adding new in ref mode
        if (mode === 'ref' && editIndex == null) return true;

        if (isEditingMode && editIndex == null) return true;

        if (mode === 'edit' && isOrderLocked) return true;

        return false;
    };
    return (
        <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
                <Box display="flex" flexDirection="column" gap={1.5} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 1, borderRight: isSmall ? 'none' : `1px solid ${themeColors.neutral.line}`, flex: { lg: '1 1 100%' }, }} >
                    <Box>
                        <DropdownProductCode
                            ref={productCodeRef}
                            id="productCode"
                            options={allProducts}
                            value={current.productCode}
                            onSelect={handleSelect}
                            onNewProductAdded={loadAllProducts}
                            connectionString={connectionString}
                            disabled={
                                mode === 'ref' ||
                                (mode === 'edit' && hasAnySOReference())
                            }
                            searchBy="code"
                            onProductMasterClose={handleProductAdded}
                            autoFocus={!initialData?.tableData?.length}
                        />
                        {!!errors.productCode && <Typography color="error" variant="caption">{errors.productCode}</Typography>}
                    </Box>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: -1, mt: -0.9 }}>
                        Available Dispatch Qty: {current.minLevel === null ? 'N/A' : Number(current.minLevel) || 'N/A'}
                    </Typography>
                    {/* <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} disabled={mode === 'edit' && hasAnySOReference()} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} /> */}
                    {isColVisible(COL.DESCRIPTION) && (
                        <DropdownProductCode
                            id="description"
                            label="Description"
                            options={allProducts}
                            value={current.description}
                            onSelect={handleSelect}
                            onNewProductAdded={loadAllProducts}
                            connectionString={connectionString}
                            searchBy="description"   // ✅ IMPORTANT
                            disabled={mode === 'edit' && hasAnySOReference()}
                            onProductMasterClose={handleProductAdded}
                        />
                    )}
                    {/* {(isColVisible('Ref.No') || isColVisible('Ref. Date') || isColVisible('Ref. Qty')) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible('Ref.No') && (
                                <TextField label="Ref. No" size="small" fullWidth value={current.refNo} onChange={handleChange('refNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible('Ref. Date') && (
                                <TextField label="Ref. Date" type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.refDate} onChange={handleChange('refDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible('Ref. Qty') && (
                                <TextField label="Ref. Qty" type="number" size="small" fullWidth value={current.refQty} onChange={handleChange('refQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )} */}
                    <Box display="flex" flexDirection="row" gap={1.5}>
                        {isColVisible(COL.UNIT) && (
                            <TextField
                                label="Unit"
                                required select fullWidth
                                value={current.UnitId || ''}
                                onChange={handleChange('UnitId')}
                                error={!!errors.UnitId}
                                helperText={errors.UnitId}
                                SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                            >
                                <option value=""></option>
                                {unitOptions.map(u => (
                                    <option key={u.UnitId} value={u.UnitId}>
                                        {u.unit}
                                    </option>
                                ))}
                            </TextField>
                        )}
                        {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}
                        {isColVisible(COL.TAX_CODE) && (
                            <Dropdown
                                id="gst"
                                label="GST"
                                valueKey="Id"
                                labelKey="value"
                                value={current.TaxId ? String(current.TaxId) : ""}
                                options={gsts}
                                required
                                onChange={(opt) => {
                                    if (!opt) {
                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: 0,
                                            TaxId: null
                                        }));
                                    } else {
                                        const gstValue = parseFloat(opt.value) || 0;

                                        // "Apply MRP in Sale?" — if MRP is already set on this
                                        // row, re-derive Rate from it using the newly-picked
                                        // GST rate, keeping Rate/MRP consistent.
                                        if (isApplyMRPInSaleEnabled && current.MRP && Number(current.MRP) > 0) {
                                            const newRate = calculateSaleRateFromMRP(Number(current.MRP), gstValue);
                                            setCurrent(prev => ({
                                                ...prev,
                                                tax: gstValue,
                                                TaxId: opt.Id,
                                                rate: newRate,
                                            }));
                                            return;
                                        }

                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: gstValue,   // % value used in calculation
                                            TaxId: opt.Id    // backend id
                                        }));
                                    }
                                }}
                                 error={!!errors.TaxId}
                            />
                        )}
                        <TextField label="SO Qty" size='small' fullWidth type="number" inputProps={{ min: 1 }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled />
                    </Box>
                    {(isColVisible(COL.BATCH_NO) || isColVisible(COL.EXP_DATE)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.BATCH_NO) && (
                                <TextField label={getColLabel(COL.BATCH_NO, 'Batch No')} size="small" fullWidth value={current.batchNo} onChange={handleChange('batchNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.EXP_DATE) && (
                                <TextField label={getColLabel(COL.EXP_DATE, 'Exp. Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.expDate} onChange={handleChange('expDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}


                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>

                        {isColVisible(COL.QTY) && (
                        <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField label="Qty" InputLabelProps={{ sx: requiredAsteriskStyle }} required type="number" size="small" fullWidth value={current.dispatchQty}
                            inputProps={{
                                min: 0,
                                max: (() => {
                                    const product = productMap.get(current.Id);

                                    const minLevel =
                                        current.minLevel === null
                                            ? (Number(product?.minLevel) || Infinity)
                                            : Number(current.minLevel) || Infinity;

                                    const hasSORef =
                                        (current.SOID || current.soId) &&
                                        (current.SODtsID || current.soDtsID);

                                    if (mode === 'add') {
                                        return minLevel;
                                    }

                                    if (mode === 'edit' && hasSORef) {
                                        return Math.min(Number(current.qty) || 1, minLevel);
                                    }

                                    if (mode === 'ref') {
                                        return Math.min(Number(current.qty) || 1, minLevel);
                                    }

                                    // ✅ edit mode without SO → free till minLevel
                                    return minLevel;
                                })(),
                                step: 'any'
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: errors.dispatchQty ? 'red' : undefined }, }}
                            onChange={handleChange('dispatchQty')}
                            onBlur={() => {
                                const product = productMap.get(current.Id);

                                const soQty = Number(current.qty) || 0;

                                const minLevel =
                                    current.minLevel === null
                                        ? (Number(product?.minLevel) || Infinity)
                                        : Number(current.minLevel) || Infinity;

                                const hasSORef =
                                    (current.SOID || current.soId) &&
                                    (current.SODtsID || current.soDtsID);

                                let limit;

                                if (mode === 'add') {
                                    limit = minLevel;
                                }
                                else if (mode === 'edit' && hasSORef) {
                                    limit = Math.min(soQty, minLevel);
                                }
                                else {
                                    limit = minLevel;
                                }

                                let value = Number(current.dispatchQty);

                                // Only zero / negative / empty falls back to 1 — a decimal
                                // below 1 (e.g. 0.45) is a valid quantity and is kept.
                                if (!(value > 0)) {
                                    value = 1;
                                }

                                if (value > limit) {
                                    value = limit;
                                }

                                setCurrent(prev => ({
                                    ...prev,
                                    dispatchQty: value
                                }));
                            }}
                            error={!!errors.dispatchQty}
                            helperText={errors.dispatchQty}
                            disabled={mode === 'edit' && hasAnySOReference()}
                        />
                        </Box>
                        )}

                        {isApplyMRPInSaleEnabled && (
                        <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField
                            label="MRP"
                            size="small"
                            fullWidth
                            type="number"
                            inputProps={{ min: 0 }}
                            value={current.MRP}
                            onChange={(e) => {
                                const val = e.target.value;
                                const mrpValue = Number(val) || 0;

                                setCurrent(prev => ({
                                    ...prev,
                                    MRP: val === '' ? '' : mrpValue
                                }));

                                if (mrpValue > 0 && current.tax > 0) {
                                    const newRate = calculateSaleRateFromMRP(mrpValue, current.tax);
                                    setCurrent(prev => ({
                                        ...prev,
                                        rate: newRate,
                                    }));
                                }
                            }}
                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                            disabled={mode === 'edit' && hasAnySOReference()}
                        />
                        </Box>
                        )}

                        {isColVisible(COL.RATE) && (
                        <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField label="Rate" size="small" fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} error={!!errors.rate} helperText={errors.rate} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled={(mode === 'edit' && hasAnySOReference()) || isApplyMRPInSaleEnabled} />
                        </Box>
                        )}

                        {isColVisible(COL.DISC) && (
                        <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField label={getColLabel(COL.DISC, 'Disc%')} size="small" fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleBaseFieldChange('disc')} error={!!errors.disc} helperText={errors.disc} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled={mode === 'edit' && hasAnySOReference()} />
                        </Box>
                        )}

                    </Box>
                    {(isColVisible(COL.TYPE) || isColVisible(COL.SIZE) || isColVisible(COL.COLOR)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.TYPE) && (
                                <TextField label={getColLabel(COL.TYPE, 'Type')} size="small" fullWidth value={current.type} onChange={handleChange('type')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.SIZE) && (
                                <TextField label={getColLabel(COL.SIZE, 'Size')} size="small" fullWidth value={current.size} onChange={handleChange('size')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.COLOR) && (
                                <TextField label={getColLabel(COL.COLOR, 'Color')} size="small" fullWidth value={current.color} onChange={handleChange('color')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.PKG) || isColVisible(COL.FREE_QTY) || isColVisible(COL.PER)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PKG) && (
                                <TextField label={getColLabel(COL.PKG, 'Pkg')} size="small" fullWidth value={current.pkg || ''} onChange={handleChange('pkg')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.FREE_QTY) && (
                                <TextField label={getColLabel(COL.FREE_QTY, 'Free Qty')} type="number" size="small" fullWidth value={current.freeQty} onChange={handleChange('freeQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PER) && (
                                <TextField label={getColLabel(COL.PER, 'Per')} size="small" fullWidth value={current.per} onChange={handleChange('per')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH1) || isColVisible(COL.OTH2) || isColVisible(COL.OTH3)) && (
                        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1.5}>
                            {isColVisible(COL.OTH1) && (
                                <TextField label={getColLabel(COL.OTH1, 'Oth 1')} size="small" fullWidth type="number" value={current[othDisplayField('oth1', COL.OTH1)] || ''} onChange={handleOthChange('oth1', COL.OTH1)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && (
                                <TextField label={`${getColLabel(COL.OTH1, 'Oth 1')} Amount`} size="small" fullWidth disabled value={current.oth1Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && (
                                <TextField label={getColLabel(COL.OTH2, 'Oth 2')} size="small" fullWidth type="number" value={current[othDisplayField('oth2', COL.OTH2)] || ''} onChange={handleOthChange('oth2', COL.OTH2)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && (
                                <TextField label={`${getColLabel(COL.OTH2, 'Oth 2')} Amount`} size="small" fullWidth disabled value={current.oth2Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && (
                                <TextField label={getColLabel(COL.OTH3, 'Oth 3')} size="small" fullWidth type="number" value={current[othDisplayField('oth3', COL.OTH3)] || ''} onChange={handleOthChange('oth3', COL.OTH3)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && !isOthRupeesMode(COL.OTH3) && (
                                <TextField label={`${getColLabel(COL.OTH3, 'Oth 3')} Amount`} size="small" fullWidth disabled value={current.oth3Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.UTGST) || isColVisible(COL.GST_CESS) || isColVisible(COL.GST_OTH)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.UTGST) && (
                                <TextField label={getColLabel(COL.UTGST, 'UTGST')} size="small" fullWidth type="number" value={current.UTGST} onChange={handleChange('UTGST')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_CESS) && (
                                <TextField label={getColLabel(COL.GST_CESS, 'GST Cess')} size="small" fullWidth type="number" value={current.GSTCess} onChange={handleChange('GSTCess')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_OTH) && (
                                <TextField label={getColLabel(COL.GST_OTH, 'GST Oth')} size="small" fullWidth type="number" value={current.GSTOth} onChange={handleChange('GSTOth')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {/* PO No / PO Date */}
                    {(isColVisible(COL.PO_NO) || isColVisible(COL.PO_DATE)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PO_NO) && (
                                <TextField label={getColLabel(COL.PO_NO, 'PO No')} size="small" fullWidth value={current.PONo} onChange={handleChange('PONo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_DATE) && (
                                <TextField label={getColLabel(COL.PO_DATE, 'PO Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.PODate} onChange={handleChange('PODate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {/* PO Qty / EX4 */}
                    {(isColVisible(COL.PO_QTY) || isColVisible(COL.EX4)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.PO_QTY) && (
                                <TextField
                                    size="small"
                                    label={getColLabel(COL.PO_QTY, 'PO Qty')}
                                    type="number"
                                    value={current.POQty || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, POQty: e.target.value }))}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                            {isColVisible(COL.EX4) && (
                                <TextField
                                    size="small"
                                    label="EX4"
                                    value={current.ex4 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, ex4: e.target.value }))}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                        </Box>
                    )}
                    {/* EX5 / EXQty6 */}
                    {(isColVisible(COL.EX5) || isColVisible(COL.EX_QTY6)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.EX5) && (
                                <TextField
                                    size="small"
                                    label="EX5"
                                    value={current.ex5 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, ex5: e.target.value }))}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                            {isColVisible(COL.EX_QTY6) && (
                                <TextField
                                    size="small"
                                    label="EXQty6"
                                    type="number"
                                    value={current.exQty6 || ''}
                                    onChange={(e) => setCurrent(p => ({ ...p, exQty6: e.target.value }))}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                        </Box>
                    )}
                    {/* Grade */}
                    {isColVisible(COL.SERIAL_NO) && (
                        <TextField
                            size="small"
                            label="Serial No"
                            value={current.serialNo || ''}
                            onChange={(e) => setCurrent(p => ({ ...p, serialNo: e.target.value }))}
                            disabled={rowIsInvoiceLocked(current)}
                            fullWidth
                        />
                    )}
                    {/* Oth 4 / Oth 5 */}
                    {(isColVisible(COL.OTH4) || isColVisible(COL.OTH5)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH4) && (
                                <TextField
                                    size="small"
                                    type="number"
                                    label={getColLabel(COL.OTH4, 'Oth 4')}
                                    value={current[othDisplayField('oth4', COL.OTH4)] || ''}
                                    onChange={handleOthChange('oth4', COL.OTH4)}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                            {isColVisible(COL.OTH4) && !isOthRupeesMode(COL.OTH4) && (
                                <TextField
                                    size="small"
                                    disabled
                                    label={`${getColLabel(COL.OTH4, 'Oth 4')} Amount`}
                                    value={current.oth4Amt || ''}
                                />
                            )}
                            {isColVisible(COL.OTH5) && (
                                <TextField
                                    size="small"
                                    type="number"
                                    label={getColLabel(COL.OTH5, 'Oth 5')}
                                    value={current[othDisplayField('oth5', COL.OTH5)] || ''}
                                    onChange={handleOthChange('oth5', COL.OTH5)}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                            {isColVisible(COL.OTH5) && !isOthRupeesMode(COL.OTH5) && (
                                <TextField
                                    size="small"
                                    disabled
                                    label={`${getColLabel(COL.OTH5, 'Oth 5')} Amount`}
                                    value={current.oth5Amt || ''}
                                />
                            )}
                        </Box>
                    )}
                    {/* Oth 6 / Oth 7 */}
                    {(isColVisible(COL.OTH6) || isColVisible(COL.OTH7)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH6) && (
                                <TextField
                                    size="small"
                                    type="number"
                                    label={getColLabel(COL.OTH6, 'Oth 6')}
                                    value={current[othDisplayField('oth6', COL.OTH6)] || ''}
                                    onChange={handleOthChange('oth6', COL.OTH6)}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                            {isColVisible(COL.OTH6) && !isOthRupeesMode(COL.OTH6) && (
                                <TextField
                                    size="small"
                                    disabled
                                    label={`${getColLabel(COL.OTH6, 'Oth 6')} Amount`}
                                    value={current.oth6Amt || ''}
                                />
                            )}
                            {isColVisible(COL.OTH7) && (
                                <TextField
                                    size="small"
                                    type="number"
                                    label={getColLabel(COL.OTH7, 'Oth 7')}
                                    value={current[othDisplayField('oth7', COL.OTH7)] || ''}
                                    onChange={handleOthChange('oth7', COL.OTH7)}
                                    disabled={rowIsInvoiceLocked(current)}
                                />
                            )}
                            {isColVisible(COL.OTH7) && !isOthRupeesMode(COL.OTH7) && (
                                <TextField
                                    size="small"
                                    disabled
                                    label={`${getColLabel(COL.OTH7, 'Oth 7')} Amount`}
                                    value={current.oth7Amt || ''}
                                />
                            )}
                        </Box>
                    )}
                    {isColVisible(COL.AMOUNT) && (
                        <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                    )}
                    {isColVisible(COL.REMARK) && (
                        <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} disabled={mode === 'edit' && hasAnySOReference()} inputProps={{ maxLength: 250 }} helperText={`${(current.remark || '').length}/250 characters`} />
                    )}
                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                        {isShowOnlineStockEnabled && current.Id && (
                            <Box display="flex" gap={2} justifyContent="center">
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: themeColors.neutral.sub }}>
                                        Closing Stock
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: onlineStockDetails.closingStock <= 0 ? themeColors.error.dark : themeColors.success.dark,
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.closingStock !== null ? onlineStockDetails.closingStock.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: themeColors.neutral.sub }}>
                                        Max Level
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: colors.primary.main,
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.maxLevel !== null ? onlineStockDetails.maxLevel.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: themeColors.neutral.sub }}>
                                        Min Level
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f57c00',
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.minLevel !== null ? onlineStockDetails.minLevel.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        <Button
                            variant="outlined"
                            onClick={addProduct}
                            sx={{ minWidth: 180 }}
                            disabled={isAddProductDisabled()}
                        >
                            {editIndex != null ? 'Update Product' : 'Add Product'}
                        </Button>
                    </Box>
                    </Box>
                <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
                    {isMobile ? (
                        <Box>
                            {rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((row, i) => (
                                <Box
                                    key={i}
                                    sx={{
                                        border: `1px solid ${themeColors.neutral.lineStrong}`,
                                        borderRadius: 2,
                                        p: 1.5,
                                        mb: 1.5,
                                        color: (mode === 'edit' &&
                                            (rowHasSOReference(row) || rowIsInvoiceLocked(row))) && "text.disabled",
                                        cursor: (mode === 'edit' &&
                                            (rowHasSOReference(row) || rowIsInvoiceLocked(row))) ? "not-allowed" : "pointer",
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600 }}>
                                        {row.productCode} —{" "}
                                        <Box
                                            component="span"
                                            sx={{
                                                fontStyle: "italic",
                                                fontWeight: "normal",
                                                display: "inline",
                                                wordBreak: "break-word",
                                                whiteSpace: "normal"
                                            }}
                                        >
                                            {row.description}
                                        </Box>
                                    </Typography>

                                    {(row.SONumber || row.SODate) && (
                                        <Typography variant="caption" display="block" color='blue'>
                                            {row.SONumber && `OrderNo: ${row.SONumber}`}
                                            {row.SODate && ` | Date: ${row.SODate}`}
                                        </Typography>
                                    )}

                                    <Grid container justifyContent="space-between">
                                        <Typography>Qty:</Typography>
                                        <Typography>{row.qty}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Rate:</Typography>
                                        <Typography>₹{row.rate}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Disc:</Typography>
                                        <Typography>{row.disc}%</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Amount:</Typography>
                                        <Typography>₹{row.amount}</Typography>
                                    </Grid>

                                    {/* TAX INFO */}
                                    <Grid container justifyContent="space-between">
                                        <Typography>GST:</Typography>
                                        <Typography>{row.tax}%</Typography>
                                    </Grid>

                                    {state?.toLowerCase() === compState?.toLowerCase() ? (
                                        <>
                                            <Grid container justifyContent="space-between" alignItems="center">
                                                <Typography>CGST</Typography>
                                                <Typography>₹{formatINR(row.cgst)}</Typography>
                                            </Grid>
                                            <Grid container justifyContent="space-between" alignItems="center" >
                                                <Typography>SGST</Typography>
                                                <Typography>₹{formatINR(row.sgst)}</Typography>
                                            </Grid>
                                        </>
                                    ) : (
                                        row.igst > 0 && (
                                            <Grid container justifyContent="space-between" alignItems="center">
                                                <Typography>IGST</Typography>
                                                <Typography>₹{formatINR(row.igst)}</Typography>
                                            </Grid>
                                        )
                                    )}

                                    {/* Remark */}
                                    {row.remark && row.remark.trim() !== '' && (
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mt: 1,
                                                display: 'block',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'anywhere',
                                                whiteSpace: 'normal'
                                            }}
                                        >
                                            Remark: {row.remark}
                                        </Typography>
                                    )}

                                    {/* DELETE / EDIT BUTTONS IF NEEDED */}
                                    <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
                                        <IconButton size="small" onClick={() => editRow(i)}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={(mode === 'edit' &&
                                            (rowHasSOReference(row) || rowIsInvoiceLocked(row)))}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <DataGrid
                            rows={rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((r, i) => ({ ...r, id: i + 1, index: i }))}
                            columns={columns}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            disableRowSelectionOnClick
                            hideFooter
                            sx={{
                                mt: 5,
                                border: `1px solid ${themeColors.neutral.lineStrong}`,
                                borderRadius: 1,
                                '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface }
                            }}
                        />
                    )}
                    <Box mt={3}>
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Basic Amount</Typography>
                            <Typography>₹{formatINR(totals.basic)}</Typography>
                        </Grid>
                        <Typography variant="caption" color="text.secondary" display="block" mb={1}>
                            Total Discounted Amount: ₹{formatINR(totals.discount)}
                        </Typography>

                        {additionalCharges.length > 0 && (
                            <Box mb={2}>
                                <Accordion
                                    expanded={chargesCollapsibleOpen !== false ? true : chargesCollapsibleOpen}
                                    onChange={() => setChargesCollapsibleOpen(!chargesCollapsibleOpen)}
                                    sx={{ width: '100%' }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ py: 0.75, minHeight: 'auto' }}>
                                        <Typography variant="subtitle2">Charges</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ py: 1, px: 1 }}>
                                        <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <colgroup>
                                                    <col style={{ width: '45%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '19%' }} />
                                                </colgroup>
                                                <thead>
                                                    <tr style={{ backgroundColor: themeColors.neutral.surfaceMuted, borderBottom: `2px solid ${themeColors.neutral.line}` }}>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Charge Name</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Amount</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Tax</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Final Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {additionalCharges.map(charge => {
                                                        const key = charge.TransType;
                                                        if (!chargeInputs[key]) {
                                                            updateChargeInput(key, { amount: '', taxId: charge.TaxId ?? null });
                                                        }
                                                        const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
                                                        const { finalAmount } = getChargeFinalAmounts(charge, input);

                                                        return (
                                                            <tr key={key} style={{ borderBottom: `1px solid ${themeColors.neutral.line}` }}>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    <Typography variant="caption" sx={{ fontSize: '12px' }}>{charge.ChargeName}</Typography>
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={input.amount}
                                                                        onChange={(e) => updateChargeInput(key, { amount: e.target.value })}
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    {charge.TaxEnabled ? (
                                                                        <Dropdown
                                                                            id={`charge-tax-${key}`}
                                                                            valueKey="Id"
                                                                            labelKey="value"
                                                                            value={input.taxId ? String(input.taxId) : ""}
                                                                            options={gsts}
                                                                            onChange={(opt) => updateChargeInput(key, { taxId: opt ? opt.Id : null })}
                                                                        />
                                                                    ) : (
                                                                        <Typography variant="caption" sx={{ color: themeColors.neutral.muted, fontSize: '12px' }}>N/A</Typography>
                                                                    )}
                                                                </td>
                                                                <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={finalAmount.toFixed(2)}
                                                                        disabled
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, backgroundColor: themeColors.neutral.surfaceMuted, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        )}

                        {state?.toLowerCase() === compState?.toLowerCase() ? (
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>CGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.cgst) + chargesSummary.cgst)}</Typography>
                                </Grid>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>SGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.sgst) + chargesSummary.sgst)}</Typography>
                                </Grid>
                            </>
                        ) : (
                            <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography>IGST</Typography>
                                <Typography>₹{formatINR(Number(totals.igst) + chargesSummary.igst)}</Typography>
                            </Grid>
                        )}
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
                            <Typography>₹{formatINR(totals.roundOff)}</Typography>
                        </Grid>

                        <Divider sx={{ my: 1 }} />
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Typography fontWeight={600}>Total Amount</Typography>
                            <Typography fontWeight={600}>₹{formatINR(Number(totals.total))}</Typography>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            {!!errors.global && <Typography color="error" sx={{ mt: 2 }}>{errors.global}</Typography>}
            <Box mt={0.2} display="flex" justifyContent="flex-end">
                <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={
                        isEditingMode ||
                        (mode === 'edit' && isOrderLocked)
                    }
                >
                    Next
                </Button>
            </Box>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Dialog
                open={stockWarningOpen}
                onClose={() => {
                    setStockWarningOpen(false);
                    if (stockConfirmResolve) stockConfirmResolve(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    ⚠️ Stock Warning
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ color: themeColors.error.dark, fontSize: '16px', lineHeight: 1.6 }}>
                        {stockWarningData?.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(false);
                        }}
                        sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(true);
                        }}
                        sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                    >
                        Yes, Save Anyway
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={zeroStockErrorOpen}
                onClose={() => {
                    setZeroStockErrorOpen(false);
                    if (stockConfirmResolve) stockConfirmResolve(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    {zeroStockErrorData?.isBlocked ? '❌ Cannot Add Product' : '⚠️ Zero/Negative Stock Warning'}
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ color: themeColors.error.dark, fontSize: '16px', lineHeight: 1.6 }}>
                        {zeroStockErrorData?.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    {zeroStockErrorData?.isBlocked ? (
                        // Hard block (configuration disallows adding this item) — only acknowledge and close.
                        <Button
                            variant="contained"
                            onClick={() => {
                                setZeroStockErrorOpen(false);
                                if (stockConfirmResolve) stockConfirmResolve(false);
                            }}
                            sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                        >
                            OK
                        </Button>
                    ) : (
                        <>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    setZeroStockErrorOpen(false);
                                    if (stockConfirmResolve) stockConfirmResolve(false);
                                }}
                                sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setZeroStockErrorOpen(false);
                                    if (stockConfirmResolve) stockConfirmResolve(true);
                                }}
                                sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                            >
                                Yes, Add Anyway
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* "Enable Convesrion effect in Transaction?" — Conversion Qty popup, shown when Unit is
                changed away from the product's default Unit. */}
            <Dialog
                open={conversionQtyDialogOpen}
                onClose={handleCancelConversionQty}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    Unit Conversion
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ fontSize: '14px', color: themeColors.neutral.sub, mb: 2 }}>
                        How many {pendingUnitChange?.unit || 'unit'} make 1 {current.unit || 'base unit'}?
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Conversion Qty"
                        size="small"
                        type="text"
                        value={conversionQtyInput}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === '' || /^\d*\.?\d{0,4}$/.test(val)) setConversionQtyInput(val);
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={handleCancelConversionQty}
                        sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmConversionQty}
                        sx={{ bgcolor: colors.primary.main, '&:hover': { bgcolor: '#0d5dc7' } }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </Paper>
    );
};

export default ProductDetails;